import React from 'react'

import type { Icon, IconProps } from '../types'
import { IconBase } from './IconBase'
import { makeIcon } from './makeIcon'

export const AirtableIcon = makeIcon({
  displayName: 'AirtableIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M7.141 1.449L1.18 3.916a.4.4 0 0 0 .005.741l5.988 2.375a2.221 2.221 0 0 0 1.638 0l5.987-2.375a.4.4 0 0 0 .005-.74L8.84 1.448a2.221 2.221 0 0 0-1.699 0z"
        fill="#FFBF00"
      />
      <path
        d="M8.522 8.329v5.932a.4.4 0 0 0 .547.372l6.671-2.59a.4.4 0 0 0 .252-.372V5.739a.4.4 0 0 0-.546-.372l-6.672 2.59a.4.4 0 0 0-.252.372z"
        fill="#26B5F8"
      />
      <path
        d="M6.964 8.635l-1.98.956-.201.097-4.18 2.003c-.265.128-.603-.065-.603-.36V5.764c0-.106.055-.198.128-.267a.454.454 0 0 1 .101-.076c.1-.06.242-.076.363-.028l6.339 2.512c.322.127.347.579.033.73z"
        fill="#ED3049"
      />
      <path
        d="M6.964 8.635l-1.98.956L.128 5.496a.454.454 0 0 1 .101-.076c.1-.06.242-.076.363-.028l6.339 2.512c.322.127.347.579.033.73z"
        fill="#000"
        fillOpacity=".25"
      />
    </g>
  ),
})

export const AirtableGreyIcon = makeIcon({
  displayName: 'AirtableGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M7.141 1.449L1.18 3.916a.4.4 0 0 0 .005.741l5.988 2.375a2.221 2.221 0 0 0 1.638 0l5.987-2.375a.4.4 0 0 0 .005-.74L8.84 1.448a2.221 2.221 0 0 0-1.699 0z" />
      <path d="M8.522 8.329v5.932a.4.4 0 0 0 .547.372l6.671-2.59a.4.4 0 0 0 .253-.372V5.739a.4.4 0 0 0-.547-.372l-6.672 2.59a.4.4 0 0 0-.252.372z" />
      <path d="M6.964 8.635l-1.98.956-.201.097-4.18 2.003c-.265.128-.603-.065-.603-.36V5.764c0-.106.055-.198.128-.267a.454.454 0 0 1 .101-.076c.1-.06.242-.076.364-.028L6.93 7.904c.322.127.347.579.033.73z" />
    </g>
  ),
})

export const AsanaIcon = makeIcon({
  displayName: 'AsanaIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 4a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm4.5 8a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM3.5 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
        fill="#F95353"
      />
    </g>
  ),
})

export const AsanaGreyIcon = makeIcon({
  displayName: 'AsanaGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 4a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zm4.5 8a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0zM3.5 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
      />
    </g>
  ),
})

export const ClickUpIcon = makeIcon({
  displayName: 'ClickUpIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0z"
        fill="url(#clickup-color-radial)"
      />
      <path
        d="M7.972 12.752c3.671 0 4.917-3.303 3.39-4.352-.011 4.114-6.644 4.1-6.654 0-1.63 1.049-.406 4.352 3.264 4.352z"
        fill="#fff"
      />
      <path
        d="M10.794 5.367c1.187 1.008 1.217 1.893 1.204 2.08L8.004 4.872 4.002 7.447c-.013-.186.016-1.073 1.203-2.08.467-.363 1.478-1.228 2.148-1.805a1.003 1.003 0 0 1 1.304-.006l2.137 1.811z"
        fill="#fff"
      />
      <defs>
        <radialGradient
          id="clickup-color-radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8 8) scale(10.7651)"
        >
          <stop stopColor="#6A5FD7" />
          <stop offset=".21" stopColor="#6A5FD7" />
          <stop offset="1" stopColor="#4B43AD" />
        </radialGradient>
      </defs>
    </g>
  ),
})

export const ClickUpGreyIcon = makeIcon({
  displayName: 'ClickUpGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zm-.028 12.752c3.671 0 4.917-3.303 3.39-4.352-.011 4.114-6.644 4.1-6.654 0-1.63 1.049-.406 4.352 3.264 4.352zm4.026-5.305c.013-.187-.017-1.072-1.204-2.08L8.657 3.556a1.003 1.003 0 0 0-1.304.006c-.67.577-1.681 1.442-2.148 1.805-1.187 1.007-1.216 1.894-1.203 2.08l4.002-2.575 3.994 2.575z"
      />
    </g>
  ),
})

export const SlackIcon = makeIcon({
  displayName: 'SlackIcon',
  content: (
    <g>
      <path
        d="M7.56 1.68v1.68H5.88a1.68 1.68 0 1 1 1.68-1.68z"
        fill="#36C5F0"
      />
      <path
        d="M14.32 7.56h-1.68V5.88a1.68 1.68 0 1 1 1.68 1.68zM11.79 5.88a1.68 1.68 0 1 1-3.36-.001l.001-4.199a1.68 1.68 0 0 1 3.361.001l-.001 4.2z"
        fill="#2EB67D"
      />
      <path
        d="M8.446 14.32v-1.68h1.68a1.68 1.68 0 1 1-1.68 1.68zM10.117 11.79a1.68 1.68 0 1 1 0-3.36l4.202-.001a1.68 1.68 0 1 1 0 3.361h-4.202z"
        fill="#ECB22E"
      />
      <path
        d="M1.68 8.44h1.68v1.68a1.68 1.68 0 1 1-1.68-1.68zM4.22 10.12a1.68 1.68 0 0 1 3.36.001l-.001 4.199a1.68 1.68 0 0 1-3.361-.001l.001-4.2z"
        fill="#E01E5A"
      />
      <path
        d="M5.88 4.22a1.68 1.68 0 0 1-.001 3.36L1.68 7.579a1.68 1.68 0 1 1 .001-3.361l4.2.001z"
        fill="#36C5F0"
      />
    </g>
  ),
})

export const GoogleDocsIcon = makeIcon({
  displayName: 'GoogleDocsIcon',
  viewBox: 16,
  content: (
    <>
      <g clipPath="url(#clip0_2074_28450)">
        <path
          d="M9.43096 0.5H3.28481C2.68827 0.5 2.2002 0.990909 2.2002 1.59091V15.4091C2.2002 16.0091 2.68827 16.5 3.28481 16.5H12.6848C13.2813 16.5 13.7694 16.0091 13.7694 15.4091V4.86364L11.2387 3.04545L9.43096 0.5Z"
          fill="#4285F4"
        />
        <path
          d="M9.74854 4.54688L13.7697 8.59051V4.86597L9.74854 4.54688Z"
          fill="url(#paint0_linear_2074_28450)"
        />
        <path
          d="M5.09277 12.1364H10.8774V11.4091H5.09277V12.1364ZM5.09277 13.5909H9.43124V12.8636H5.09277V13.5909ZM5.09277 8.5V9.22727H10.8774V8.5H5.09277ZM5.09277 10.6818H10.8774V9.95455H5.09277V10.6818Z"
          fill="#F1F1F1"
        />
        <path
          d="M9.43164 0.5V3.77273C9.43164 4.37545 9.91701 4.86364 10.5163 4.86364H13.7701L9.43164 0.5Z"
          fill="#A1C2FA"
        />
        <path
          d="M3.28481 0.5C2.68827 0.5 2.2002 0.990909 2.2002 1.59091V1.68182C2.2002 1.08182 2.68827 0.590909 3.28481 0.590909H9.43096V0.5H3.28481Z"
          fill="white"
          fillOpacity="0.2"
        />
        <path
          d="M12.6848 16.4093H3.28481C2.68827 16.4093 2.2002 15.9184 2.2002 15.3184V15.4093C2.2002 16.0093 2.68827 16.5002 3.28481 16.5002H12.6848C13.2813 16.5002 13.7694 16.0093 13.7694 15.4093V15.3184C13.7694 15.9184 13.2813 16.4093 12.6848 16.4093Z"
          fill="#1A237E"
          fillOpacity="0.2"
        />
        <path
          d="M10.5163 4.86435C9.91701 4.86435 9.43164 4.37616 9.43164 3.77344V3.86435C9.43164 4.46707 9.91701 4.95526 10.5163 4.95526H13.7701V4.86435H10.5163Z"
          fill="#1A237E"
          fillOpacity="0.1"
        />
        <path
          d="M9.43096 0.5H3.28481C2.68827 0.5 2.2002 0.990909 2.2002 1.59091V15.4091C2.2002 16.0091 2.68827 16.5 3.28481 16.5H12.6848C13.2813 16.5 13.7694 16.0091 13.7694 15.4091V4.86364L9.43096 0.5Z"
          fill="url(#paint1_radial_2074_28450)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2074_28450"
          x1="11.7594"
          y1="4.89407"
          x2="11.7594"
          y2="8.59108"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1A237E" stopOpacity="0.2" />
          <stop offset="1" stopColor="#1A237E" stopOpacity="0.02" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_2074_28450"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(2.56671 0.816239) scale(18.6552 18.6552)"
        >
          <stop stopColor="white" stopOpacity="0.1" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_2074_28450">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </>
  ),
})

export const GoogleIcon = makeIcon({
  displayName: 'GoogleIcon',
  viewBox: 18,
  content: (
    <g id="Google-Button" stroke="none" fill="none">
      <g
        id="btn_google_dark_normal"
        transform="translate(-15.000000, -15.000000)"
      >
        <g id="logo_googleg_48dp" transform="translate(15.000000, 15.000000)">
          <path
            d="M17.64,9.20454545 C17.64,8.56636364 17.5827273,7.95272727 17.4763636,7.36363636 L9,7.36363636 L9,10.845 L13.8436364,10.845 C13.635,11.97 13.0009091,12.9231818 12.0477273,13.5613636 L12.0477273,15.8195455 L14.9563636,15.8195455 C16.6581818,14.2527273 17.64,11.9454545 17.64,9.20454545 L17.64,9.20454545 Z"
            id="Shape"
            fill="#4285F4"
          />
          <path
            d="M9,18 C11.43,18 13.4672727,17.1940909 14.9563636,15.8195455 L12.0477273,13.5613636 C11.2418182,14.1013636 10.2109091,14.4204545 9,14.4204545 C6.65590909,14.4204545 4.67181818,12.8372727 3.96409091,10.71 L0.957272727,10.71 L0.957272727,13.0418182 C2.43818182,15.9831818 5.48181818,18 9,18 L9,18 Z"
            id="Shape"
            fill="#34A853"
          />
          <path
            d="M3.96409091,10.71 C3.78409091,10.17 3.68181818,9.59318182 3.68181818,9 C3.68181818,8.40681818 3.78409091,7.83 3.96409091,7.29 L3.96409091,4.95818182 L0.957272727,4.95818182 C0.347727273,6.17318182 0,7.54772727 0,9 C0,10.4522727 0.347727273,11.8268182 0.957272727,13.0418182 L3.96409091,10.71 L3.96409091,10.71 Z"
            id="Shape"
            fill="#FBBC05"
          />
          <path
            d="M9,3.57954545 C10.3213636,3.57954545 11.5077273,4.03363636 12.4404545,4.92545455 L15.0218182,2.34409091 C13.4631818,0.891818182 11.4259091,0 9,0 C5.48181818,0 2.43818182,2.01681818 0.957272727,4.95818182 L3.96409091,7.29 C4.67181818,5.16272727 6.65590909,3.57954545 9,3.57954545 L9,3.57954545 Z"
            id="Shape"
            fill="#EA4335"
          />
          <polygon id="Shape" points="0 0 18 0 18 18 0 18" />
        </g>
      </g>
    </g>
  ),
})

export const GooglePlayIcon = makeIcon({
  displayName: 'GooglePlayIcon',
  viewBoxHeight: 24,
  viewBoxWidth: 21,
  content: (
    <path d="M1.101 0l11.22 11.225 3.077-3.1L1.798.212A1.48 1.48 0 0 0 1.1 0zm-.94.522A1.295 1.295 0 0 0 0 1.158v21.814c0 .175.036.333.097.473l11.48-11.486L.162.522zm16.176 8.141L13.05 11.96l3.287 3.28 4.015-2.317c.571-.333.652-.755.648-.98-.006-.37-.239-.717-.632-.93-.342-.185-2.882-1.675-4.031-2.349zm-4.016 4.03L1.004 24c.188-.01.392-.051.583-.163.443-.26 9.407-5.482 9.407-5.482l4.42-2.562-3.093-3.1z" />
  ),
})

export const GoogleDriveIconMonochrome = makeIcon({
  displayName: 'GoogleDriveIconMonochrome',
  viewBox: 16,
  content: (
    <path
      fill="#currentColor"
      fillRule="evenodd"
      d="M0 10.15 2.8 15h10.4l2.8-4.85L10.8 1H5.2L0 10.15Zm10.382-.025L8 6l-2.382 4.125h4.764Z"
      clipRule="evenodd"
    />
  ),
})

export const LinkedInIcon = makeIcon({
  displayName: 'LinkedInIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill="#007EBB"
      d="M14.8158 0H1.18089C0.529332 0 0 0.516445 0 1.15322V14.8454C0 15.4828 0.529332 16 1.18089 16H14.8158C15.4684 16 16.0002 15.4828 16.0002 14.8454V1.15322C16.0002 0.516445 15.4684 0 14.8158 0ZM3.55922 2.20278C4.3181 2.20278 4.93455 2.81934 4.93455 3.57834C4.93455 4.33789 4.3181 4.95467 3.55922 4.95467C2.79877 4.95467 2.18311 4.33789 2.18311 3.57834C2.18311 2.81934 2.79877 2.20278 3.55922 2.20278ZM2.37222 5.99845H4.74533V13.6341H2.37222V5.99845ZM8.51032 5.99844H6.23376V13.6341H8.60521V9.85678C8.60521 8.86077 8.79432 7.89611 10.0293 7.89611C11.2462 7.89611 11.2625 9.035 11.2625 9.92089V13.6341H13.634V9.44578C13.634 7.38989 13.1903 5.80844 10.7872 5.80844C9.63276 5.80844 8.85854 6.44144 8.54188 7.04166H8.51032V5.99844Z"
    />
  ),
})

export const ConfluenceIcon = makeIcon({
  displayName: 'ConfluenceIcon',
  viewBox: 16,
  content: (
    <>
      <g clipPath="url(#clip0_2074_28451)">
        <path
          d="M15.8184 3.59454C16.0375 3.25299 15.9277 2.80148 15.5839 2.58597C14.864 2.13476 13.65 1.3739 12.6947 0.775747C12.34 0.553633 11.875 0.667632 11.6435 1.0163C10.2639 3.09432 9.0351 3.73003 6.28589 2.40472C5.4493 2.00273 4.04955 1.32421 3.20673 0.915267C2.82158 0.728385 2.35928 0.900774 2.18941 1.29373C1.72764 2.36186 1.13607 3.71759 0.789519 4.51067C0.627911 4.88051 0.787404 5.31068 1.15099 5.4859C1.98266 5.88673 3.41657 6.5779 4.27021 6.99C9.32294 9.51854 13.0388 7.92767 15.8184 3.59454Z"
          fill="url(#paint0_linear_2074_28451)"
        />
        <path
          d="M0.1821 13.4016C-0.0370016 13.7431 0.0727513 14.1946 0.416583 14.4101C1.13647 14.8613 2.35053 15.6222 3.30577 16.2203C3.66048 16.4425 4.1255 16.3285 4.35698 15.9798C5.73661 13.9018 6.96539 13.2661 9.7146 14.5914C10.5512 14.9934 11.9509 15.6719 12.7938 16.0808C13.1789 16.2677 13.6412 16.0953 13.8111 15.7024C14.2728 14.6342 14.8644 13.2785 15.211 12.4854C15.3726 12.1156 15.2131 11.6854 14.8495 11.5102C14.0178 11.1094 12.5839 10.4182 11.7303 10.0061C6.67755 7.47755 2.96174 9.06843 0.1821 13.4016Z"
          fill="url(#paint1_linear_2074_28451)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2074_28451"
          x1="1.07441"
          y1="-0.710464"
          x2="4.91853"
          y2="7.91591"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2074_28451"
          x1="14.9261"
          y1="17.7066"
          x2="11.082"
          y2="9.08018"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
        <clipPath id="clip0_2074_28451">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </>
  ),
})

export const TwitterXIcon = makeIcon({
  displayName: 'TwitterXIcon',
  viewBox: 16,
  content: (
    <path d="M9.31264 6.77143L15.1379 0H13.7575L8.69942 5.87954L4.65953 0H0L6.10911 8.8909L0 15.9918H1.38049L6.72197 9.78279L10.9884 15.9918H15.6479L9.3123 6.77143H9.31264ZM7.42187 8.96923L6.8029 8.0839L1.87789 1.03921H3.99824L7.97277 6.7245L8.59175 7.60983L13.7582 14.9998H11.6378L7.42187 8.96957V8.96923Z" />
  ),
})

export const ConfluenceIconMonochrome = makeIcon({
  displayName: 'ConfluenceIconMonochrome',
  viewBoxWidth: 24,
  viewBoxHeight: 25,
  content: (
    <>
      <path
        fill="url(#confluence-icon-gradient-a)"
        d="M23.923 4.836a.734.734 0 0 0-.238-1.01L18.72.717a.765.765 0 0 0-1.047.243c-2.157 3.37-3.983 4.456-8.244 2.402-1.381-.664-3.786-1.83-4.973-2.406a.75.75 0 0 0-1.017.38c-.776 1.799-1.882 4.331-2.4 5.517a.747.747 0 0 0 .361.974l5.005 2.413c7.698 3.852 13.328 1.33 17.518-5.403Z"
      />
      <path
        fill="url(#confluence-icon-gradient-b)"
        d="M.077 20.164a.734.734 0 0 0 .238 1.01l4.965 3.11a.765.765 0 0 0 1.047-.243c2.157-3.37 3.983-4.456 8.245-2.402 1.38.664 3.785 1.83 4.972 2.406a.75.75 0 0 0 1.017-.38c.776-1.799 1.882-4.331 2.4-5.517a.747.747 0 0 0-.361-.974l-5.005-2.413C9.897 10.91 4.268 13.431.077 20.164Z"
      />
      <defs>
        <linearGradient
          id="confluence-icon-gradient-a"
          x1="1.611"
          x2="7.378"
          y1="-1.312"
          y2="11.628"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".18" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
        <linearGradient
          id="confluence-icon-gradient-b"
          x1="22.389"
          x2="16.622"
          y1="26.312"
          y2="13.372"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".18" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
      </defs>
    </>
  ),
})

export const ConfluenceGreyIcon = makeIcon({
  displayName: 'ConfluenceGreyIcon',
  content: (
    <g>
      <path d="M15.948 2.891a.49.49 0 0 0-.158-.673L12.48.144a.51.51 0 0 0-.698.162c-1.438 2.247-2.655 2.97-5.496 1.601C5.365 1.465 3.762.687 2.97.303a.5.5 0 0 0-.677.253c-.518 1.2-1.255 2.888-1.6 3.679a.498.498 0 0 0 .24.649L4.27 6.493c5.132 2.568 8.885.886 11.678-3.602ZM.051 13.109a.49.49 0 0 0 .16.673l3.309 2.074a.51.51 0 0 0 .698-.162c1.438-2.247 2.655-2.97 5.496-1.602.921.443 2.524 1.22 3.316 1.605a.5.5 0 0 0 .677-.253 971.72 971.72 0 0 1 1.6-3.679.498.498 0 0 0-.24-.649L11.73 9.507C6.598 6.94 2.845 8.621.051 13.11Z" />
    </g>
  ),
})

export const DrawIOIcon = makeIcon({
  displayName: 'DrawIOIcon',
  viewBox: 719,
  content: (
    <g
      transform="translate(0.000000,719.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path d="M0 3595 l0 -3595 3595 0 3595 0 0 3595 0 3595 -3595 0 -3595 0 0 -3595z m4319 2735 c162 -27 286 -148 321 -313 7 -36 10 -238 8 -623 -3 -569 -3 -569 -26 -626 -35 -86 -108 -160 -202 -206 l-78 -38 397 -677 396 -677 370 0 c398 -1 493 -8 564 -42 71 -34 154 -119 187 -191 l29 -62 0 -620 0 -620 -32 -66 c-40 -81 -102 -140 -191 -182 l-67 -32 -765 0 -765 0 -63 29 c-81 37 -171 131 -204 213 l-23 58 0 605 0 605 32 67 c76 162 212 237 431 238 28 0 52 2 52 4 0 1 -177 304 -393 672 l-394 669 -310 3 -310 2 -392 -668 c-215 -368 -391 -671 -391 -674 0 -3 45 -8 101 -12 159 -11 251 -56 329 -159 77 -102 75 -79 75 -757 l0 -605 -32 -67 c-54 -115 -150 -191 -273 -217 -40 -9 -250 -11 -785 -9 l-730 3 -65 31 c-113 53 -171 119 -210 233 -20 61 -21 76 -18 659 l3 597 27 57 c47 101 140 182 253 221 18 6 200 13 449 16 l419 6 393 670 c216 369 393 674 394 678 0 4 -8 10 -17 13 -133 42 -226 133 -267 260 -15 45 -16 117 -14 655 l3 604 27 56 c54 109 173 198 290 218 77 13 1388 13 1467 1z" />
    </g>
  ),
})

export const FigmaIcon = makeIcon({
  displayName: 'FigmaIcon',
  viewBox: 16,
  content: (
    <g>
      <g clipPath="url(#figma-color-clip)">
        <path
          d="M5.667 16a2.668 2.668 0 0 0 2.667-2.667v-2.667H5.667a2.668 2.668 0 0 0 0 5.334z"
          fill="#0ACF83"
        />
        <path
          d="M3 8a2.668 2.668 0 0 1 2.667-2.667h2.667v5.333H5.667A2.667 2.667 0 0 1 3 8z"
          fill="#A259FF"
        />
        <path
          d="M3 2.667A2.668 2.668 0 0 1 5.667 0h2.667v5.333H5.667A2.667 2.667 0 0 1 3 2.667z"
          fill="#F24E1E"
        />
        <path
          d="M8.333 0H11a2.667 2.667 0 0 1 0 5.333H8.333V0z"
          fill="#FF7262"
        />
        <path
          d="M13.667 8a2.668 2.668 0 0 1-5.334 0 2.668 2.668 0 0 1 5.334 0z"
          fill="#1ABCFE"
        />
      </g>
      <defs>
        <clipPath id="figma-color-clip">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const FigmaGreyIcon = makeIcon({
  displayName: 'FigmaGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M5.668 16a2.668 2.668 0 0 0 2.666-2.667v-2.666H5.668a2.668 2.668 0 0 0 0 5.333z" />
      <path d="M3.001 8a2.668 2.668 0 0 1 2.667-2.667h2.666v5.334H5.668A2.668 2.668 0 0 1 3 8z" />
      <path d="M3.001 2.667A2.668 2.668 0 0 1 5.668 0h2.666v5.333H5.668A2.668 2.668 0 0 1 3 2.667z" />
      <path d="M8.334 0h2.667a2.668 2.668 0 0 1 0 5.333H8.334V0z" />
      <path d="M13.668 8a2.668 2.668 0 0 1-5.334 0 2.668 2.668 0 0 1 5.334 0z" />
    </g>
  ),
})

export const GoogleDriveIcon = makeIcon({
  displayName: 'GoogleDriveIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fill="#00AC47"
        d="M8.002 5.607 5.485 1.244a.779.779 0 0 1 .276-.175c-.742.24-1.083 1.059-1.083 1.059L.08 10.095a2.3 2.3 0 0 0-.075.674h5.019l2.978-5.162Z"
      />
      <path
        fill="#FFBA00"
        d="m8.002 5.607 2.978 5.162h5.018a2.3 2.3 0 0 0-.074-.674l-4.598-7.967s-.342-.819-1.083-1.059a.787.787 0 0 1 .276.175L8.002 5.607Z"
      />
      <path
        fill="#00832D"
        d="m8.002 5.607 2.516-4.363a.779.779 0 0 0-.276-.175 1.382 1.382 0 0 0-.355-.065H6.115a1.316 1.316 0 0 0-.355.065.787.787 0 0 0-.276.175l2.517 4.363Z"
      />
      <path
        fill="#2684FC"
        d="m5.024 10.77-2.488 4.312s-.083-.04-.195-.12c.353.266.696.323.696.323h9.772c.54 0 .652-.203.652-.203l.004-.002-2.486-4.31H5.024Z"
      />
      <path
        fill="#0066DA"
        d="M5.024 10.77H.005c.026.585.284.928.284.928l.189.321.022.03.41.708.922 1.576c.027.064.059.122.092.178.012.019.024.04.038.058l.01.016c.114.158.242.28.37.376.112.083.195.121.195.121l2.488-4.313h-.001Z"
      />
      <path
        fill="#EA4335"
        d="M10.979 10.77h5.018c-.025.585-.284.928-.284.928l-.188.321-.022.03-.41.708-.922 1.576a1.449 1.449 0 0 1-.092.178c-.013.019-.024.04-.038.058l-.01.016a1.75 1.75 0 0 1-.37.376c-.112.083-.195.121-.195.121l-2.488-4.313Z"
      />
    </g>
  ),
})

export const GoogleDriveGreyIcon = makeIcon({
  displayName: 'GoogleDriveGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 10.15L2.8 15h10.4l2.8-4.85L10.8 1H5.2L0 10.15zm10.382-.025L8 6l-2.382 4.125h4.764z"
      />
    </g>
  ),
})

export const GoogleMapsIcon = makeIcon({
  displayName: 'GoogleMapsIcon',
  viewBox: 16,
  content: (
    <g>
      <g clipPath="url(#google-maps-color-path-0)">
        <path
          d="M7.994 0C5.18 0 2.9 2.177 2.9 4.863c.002.838.201 1.662.635 2.39.131.214.253.428.362.64.1.153.197.306.288.458.104.145.204.29.3.437.398.537.76 1.064 1.105 1.57.24.387.51.801.748 1.211.718 1.243 1.217 2.457 1.397 4.225v.004c.055.124.157.202.267.202.122 0 .233-.095.282-.242.183-1.748.68-2.954 1.392-4.189.238-.41.508-.824.749-1.212.345-.505.707-1.032 1.104-1.569.096-.146.196-.292.3-.437.091-.152.188-.305.289-.458.109-.212.23-.426.361-.64.433-.729.607-1.552.609-2.39C13.088 2.177 10.808 0 7.994 0z"
          fill="#DD4B3E"
        />
        <path
          d="M7.994 6.552c.977 0 1.77-.757 1.77-1.69 0-.932-.793-1.689-1.77-1.689-.978 0-1.77.757-1.77 1.69 0 .932.792 1.689 1.77 1.689z"
          fill="#802D27"
        />
      </g>
      <defs>
        <clipPath id="google-maps-color-path-0">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const GoogleMapsGreyIcon = makeIcon({
  displayName: 'GoogleMapsGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <g clipPath="url(#google-maps-grey-path-0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.9 4.863C2.9 2.177 5.18 0 7.994 0c2.813 0 5.094 2.177 5.094 4.863-.001.838-.176 1.661-.609 2.39-.13.214-.252.428-.361.64-.101.153-.198.306-.288.458-.105.145-.205.29-.3.437a49.39 49.39 0 0 0-1.105 1.57 59.06 59.06 0 0 1-.221.351c-.178.282-.36.572-.528.86-.712 1.234-1.209 2.44-1.392 4.189-.049.147-.16.242-.282.242-.11 0-.212-.078-.267-.202v-.004c-.18-1.768-.68-2.982-1.397-4.225-.167-.288-.35-.578-.527-.86-.076-.119-.15-.236-.221-.351a49.486 49.486 0 0 0-1.105-1.57 11.41 11.41 0 0 0-.3-.437c-.09-.152-.187-.305-.288-.458a9.772 9.772 0 0 0-.362-.64c-.434-.728-.633-1.552-.635-2.39zm6.863 0c0 .932-.792 1.689-1.77 1.689-.976 0-1.769-.757-1.769-1.69 0-.932.793-1.689 1.77-1.689s1.77.757 1.77 1.69z"
        />
      </g>
      <defs>
        <clipPath id="google-maps-grey-path-0">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const GitHubIcon = makeIcon({
  displayName: 'GitHubIcon',
  viewBox: 16,
  content: (
    <g className="github-icon">
      <style>
        {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
        {`
          .github-icon, .force-light-mode .github-icon {
            --github-icon-color: #161614;
          }
          .dark-mode .github-icon {
            --github-icon-color: #FFF;
          }
        `}
      </style>
      <path
        d="M8 .197A8.001 8.001 0 0 0 5.472 15.79c.4.074.547-.174.547-.384 0-.192-.008-.821-.011-1.49-2.226.484-2.696-.943-2.696-.943-.364-.925-.888-1.171-.888-1.171-.726-.497.055-.486.055-.486.803.056 1.226.824 1.226.824.714 1.223 1.872.87 2.328.665.072-.517.28-.87.508-1.07-1.777-.202-3.645-.888-3.645-3.953 0-.874.313-1.587.825-2.148-.084-.201-.357-1.015.077-2.117 0 0 .672-.215 2.2.82a7.59 7.59 0 0 1 4.007 0c1.527-1.035 2.198-.82 2.198-.82.435 1.102.162 1.916.078 2.117.512.56.824 1.274.824 2.148 0 3.072-1.872 3.749-3.653 3.947.288.248.544.736.544 1.482 0 1.07-.01 1.931-.01 2.195 0 .213.145.462.55.384A8.005 8.005 0 0 0 16 8.197a8 8 0 0 0-8-8zM2.996 11.594c-.017.04-.08.051-.137.024-.057-.027-.09-.08-.071-.12.018-.04.08-.052.137-.025.058.027.091.08.071.12zm.394.352c-.038.035-.113.018-.163-.037-.051-.057-.063-.13-.024-.167.038-.035.112-.019.164.037.053.056.063.13.023.166zm.27.448c-.05.034-.128.002-.179-.07-.05-.07-.049-.156 0-.191.049-.036.128-.004.179.067.05.07.05.16 0 .194zm.456.52c-.043.048-.137.035-.205-.032-.069-.067-.09-.156-.046-.205.044-.048.139-.034.208.032.069.067.09.158.043.206v-.001zm.59.175c-.019.064-.109.091-.2.064-.09-.027-.15-.1-.131-.164.018-.063.11-.093.2-.064.092.029.15.101.132.165zm.673.075c.002.066-.075.12-.17.122-.095.001-.173-.051-.174-.116-.001-.065.075-.121.17-.123.096-.001.173.052.173.117zm.66-.025c.01.064-.055.13-.15.148-.095.017-.179-.023-.19-.087-.012-.064.055-.132.148-.15.093-.016.179.024.19.09l.001-.001z"
        fill="var(--github-icon-color)"
      />
    </g>
  ),
})

export const GitLabIcon = makeIcon({
  displayName: 'GitLabIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M15.7336 6.33241L15.7112 6.27273L13.5334 0.372158C13.4891 0.25651 13.4107 0.158405 13.3093 0.0919202C13.2079 0.0265645 13.0896 -0.00491288 12.9705 0.00173808C12.8513 0.00838904 12.7369 0.0528481 12.6428 0.129112C12.5498 0.207566 12.4823 0.313874 12.4496 0.433568L10.9791 5.10421H5.02496L3.55454 0.433568C3.52265 0.313222 3.45502 0.206381 3.36126 0.128247C3.26719 0.051983 3.15284 0.00752392 3.03365 0.000872965C2.91447 -0.00577799 2.79619 0.0256994 2.69478 0.0910551C2.59367 0.157809 2.51528 0.255828 2.47068 0.371293L0.288786 6.26927L0.267125 6.32895C-0.0463686 7.17936 -0.0850642 8.11253 0.156872 8.98776C0.398809 9.86299 0.908262 10.6328 1.60842 11.1812L1.61592 11.1873L1.63591 11.202L4.95332 13.7812L6.59453 15.0708L7.59425 15.8545C7.71119 15.9466 7.85398 15.9965 8.0008 15.9965C8.14763 15.9965 8.29042 15.9466 8.40736 15.8545L9.40708 15.0708L11.0483 13.7812L14.3857 11.1864L14.394 11.1795C15.0926 10.631 15.6009 9.86195 15.8424 8.9879C16.084 8.11385 16.0458 7.18201 15.7336 6.33241Z"
        fill="#E24329"
      />
      <path
        d="M15.7336 6.33239L15.7112 6.27271C14.65 6.49883 13.6501 6.96548 12.7828 7.6393L7.99997 11.394C9.62868 12.6732 11.0466 13.7847 11.0466 13.7847L14.384 11.1899L14.3924 11.1829C15.0919 10.6345 15.601 9.86491 15.8429 8.99011C16.0848 8.11531 16.0465 7.18261 15.7336 6.33239Z"
        fill="#FC6D26"
      />
      <path
        d="M4.95331 13.7847L6.59452 15.0743L7.59424 15.8579C7.71118 15.9501 7.85397 16 8.00079 16C8.14762 16 8.29041 15.9501 8.40735 15.8579L9.40707 15.0743L11.0483 13.7847C11.0483 13.7847 9.62867 12.6698 7.99996 11.394C6.37125 12.6698 4.95331 13.7847 4.95331 13.7847Z"
        fill="#FCA326"
      />
      <path
        d="M3.2163 7.63934C2.34971 6.96413 1.34999 6.49627 0.288786 6.26929L0.267125 6.32897C-0.0463686 7.17937 -0.0850642 8.11254 0.156872 8.98778C0.398809 9.86301 0.908262 10.6329 1.60842 11.1812L1.61592 11.1873L1.63591 11.202L4.95332 13.7812C4.95332 13.7812 6.36959 12.6698 7.99997 11.3906L3.2163 7.63934Z"
        fill="#FC6D26"
      />
    </g>
  ),
})

export const GitHubGreyIcon = makeIcon({
  displayName: 'GitHubGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M8 .197A8.001 8.001 0 0 0 5.472 15.79c.4.074.547-.174.547-.384 0-.192-.008-.821-.011-1.49-2.226.484-2.696-.943-2.696-.943-.364-.925-.888-1.171-.888-1.171-.726-.497.055-.486.055-.486.803.056 1.226.824 1.226.824.714 1.223 1.872.87 2.328.665.072-.517.28-.87.508-1.07-1.777-.202-3.645-.888-3.645-3.953 0-.874.313-1.587.825-2.148-.084-.201-.357-1.015.077-2.117 0 0 .672-.215 2.2.82a7.59 7.59 0 0 1 4.007 0c1.527-1.035 2.198-.82 2.198-.82.435 1.102.162 1.916.078 2.117.512.56.824 1.274.824 2.148 0 3.072-1.872 3.749-3.653 3.947.288.248.544.736.544 1.482 0 1.07-.01 1.931-.01 2.195 0 .213.145.462.55.384A8.005 8.005 0 0 0 16 8.197a8 8 0 0 0-8-8z" />
    </g>
  ),
})

export const LoomIcon = makeIcon({
  displayName: 'LoomIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M16 7.11032H11.3214L15.3733 4.77095L14.4835 3.22928L10.4315 5.56865L12.7704 1.51705L11.2287 0.626696L8.88986 4.67829V0H7.11012V4.67873L4.77037 0.626696L3.22919 1.5166L5.56849 5.5682L1.51656 3.22928L0.626679 4.7705L4.67861 7.10987H0V8.8897H4.67816L0.626679 11.2291L1.51656 12.7707L5.56804 10.4318L3.22874 14.4834L4.77037 15.3733L7.10967 11.3213V16H8.88944V11.3217L11.2283 15.3733L12.7699 14.4834L10.4306 10.4314L14.4825 12.7707L15.3724 11.2291L11.3209 8.89012H15.9991V7.11032H16ZM8 10.4206C6.65802 10.4206 5.57028 9.33288 5.57028 7.99083C5.57028 6.6488 6.65802 5.56104 8 5.56104C9.34199 5.56104 10.4297 6.6488 10.4297 7.99083C10.4297 9.33288 9.34199 10.4206 8 10.4206Z"
        fill="#625DF5"
      />
    </g>
  ),
})

export const LoomGreyIcon = makeIcon({
  displayName: 'LoomGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M16 7.11032H11.3214L15.3733 4.77095L14.4835 3.22928L10.4315 5.56865L12.7704 1.51705L11.2287 0.626696L8.88986 4.67829V0H7.11012V4.67873L4.77037 0.626696L3.22919 1.5166L5.56849 5.5682L1.51656 3.22928L0.626679 4.7705L4.67861 7.10987H0V8.8897H4.67816L0.626679 11.2291L1.51656 12.7707L5.56804 10.4318L3.22874 14.4834L4.77037 15.3733L7.10967 11.3213V16H8.88944V11.3217L11.2283 15.3733L12.7699 14.4834L10.4306 10.4314L14.4825 12.7707L15.3724 11.2291L11.3209 8.89012H15.9991V7.11032H16ZM8 10.4206C6.65802 10.4206 5.57028 9.33288 5.57028 7.99083C5.57028 6.6488 6.65802 5.56104 8 5.56104C9.34199 5.56104 10.4297 6.6488 10.4297 7.99083C10.4297 9.33288 9.34199 10.4206 8 10.4206Z" />
    </g>
  ),
})

export const TrelloIcon = makeIcon({
  displayName: 'TrelloIcon',
  viewBox: 16,
  content: (
    <g>
      <g clipPath="url(#trello-color-clip-0)">
        <path
          d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
          fill="#3279BA"
        />
        <path
          d="M7 12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v9zm7-4a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="trello-color-clip-0">
          <path fill="#fff" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const TrelloGreyIcon = makeIcon({
  displayName: 'TrelloGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2zm6 11a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h3zm7-4a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h3z"
      />
    </g>
  ),
})

export const IntercomIcon = makeIcon({
  displayName: 'IntercomIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M13.8667 8.79677C13.8667 9.09131 13.6279 9.33011 13.3333 9.33011C13.0388 9.33011 12.8 9.09131 12.8 8.79677V4C12.8 3.70547 13.0388 3.46667 13.3333 3.46667C13.6279 3.46667 13.8667 3.70547 13.8667 4V8.79677ZM13.6805 12.1351C13.5981 12.2056 11.6224 13.8635 8.00003 13.8635C4.37764 13.8635 2.40198 12.2056 2.31958 12.135C2.09598 11.9433 2.0701 11.6066 2.26176 11.3829C2.45302 11.1597 2.78879 11.1333 3.01255 11.3241C3.0439 11.3503 4.8081 12.7967 8.00003 12.7968C11.232 12.7968 12.969 11.3398 12.9862 11.3252C13.2094 11.1335 13.5467 11.1593 13.7383 11.383C13.93 11.6066 13.9041 11.9434 13.6805 12.1351ZM2.13333 4C2.13333 3.70547 2.37212 3.46667 2.66666 3.46667C2.96124 3.46667 3.19999 3.70547 3.19999 4V8.79677C3.19999 9.09125 2.96124 9.33005 2.66666 9.33005C2.37212 9.33005 2.13333 9.09125 2.13333 8.79672V4ZM4.80004 2.93333C4.80004 2.6388 5.03884 2.4 5.33337 2.4C5.6279 2.4 5.8667 2.6388 5.8667 2.93333V10.0584C5.8667 10.3529 5.6279 10.5917 5.33337 10.5917C5.03884 10.5917 4.80004 10.3529 4.80004 10.0584V2.93333ZM7.46669 2.66347C7.46669 2.3688 7.70549 2.13013 8.00003 2.13013C8.29456 2.13013 8.53336 2.3688 8.53336 2.66347V10.3968C8.53336 10.6913 8.29456 10.9301 8.00003 10.9301C7.70549 10.9301 7.46669 10.6913 7.46669 10.3968V2.66347ZM10.1334 2.93333C10.1334 2.6388 10.3722 2.4 10.6667 2.4C10.9612 2.4 11.2 2.6388 11.2 2.93333V10.0584C11.2 10.3529 10.9612 10.5917 10.6667 10.5917C10.3722 10.5917 10.1334 10.3529 10.1334 10.0584V2.93333ZM14 0H1.99999C0.895465 0 0 0.895467 0 2L5.20832e-05 14C5.20832e-05 15.1045 0.895465 16 1.99999 16H14C15.1045 16 16 15.1045 16 14V2C16 0.895467 15.1045 0 14 0Z"
        fill="#1F8DED"
      />
    </g>
  ),
})

export const IntercomGreyIcon = makeIcon({
  displayName: 'IntercomGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M13.8667 8.79677C13.8667 9.09131 13.6279 9.33011 13.3333 9.33011C13.0388 9.33011 12.8 9.09131 12.8 8.79677V4C12.8 3.70547 13.0388 3.46667 13.3333 3.46667C13.6279 3.46667 13.8667 3.70547 13.8667 4V8.79677ZM13.6805 12.1351C13.5981 12.2056 11.6224 13.8635 8.00003 13.8635C4.37764 13.8635 2.40198 12.2056 2.31958 12.135C2.09598 11.9433 2.0701 11.6066 2.26176 11.3829C2.45302 11.1597 2.78879 11.1333 3.01255 11.3241C3.0439 11.3503 4.8081 12.7967 8.00003 12.7968C11.232 12.7968 12.969 11.3398 12.9862 11.3252C13.2094 11.1335 13.5467 11.1593 13.7383 11.383C13.93 11.6066 13.9041 11.9434 13.6805 12.1351ZM2.13333 4C2.13333 3.70547 2.37212 3.46667 2.66666 3.46667C2.96124 3.46667 3.19999 3.70547 3.19999 4V8.79677C3.19999 9.09125 2.96124 9.33005 2.66666 9.33005C2.37212 9.33005 2.13333 9.09125 2.13333 8.79672V4ZM4.80004 2.93333C4.80004 2.6388 5.03884 2.4 5.33337 2.4C5.6279 2.4 5.8667 2.6388 5.8667 2.93333V10.0584C5.8667 10.3529 5.6279 10.5917 5.33337 10.5917C5.03884 10.5917 4.80004 10.3529 4.80004 10.0584V2.93333ZM7.46669 2.66347C7.46669 2.3688 7.70549 2.13013 8.00003 2.13013C8.29456 2.13013 8.53336 2.3688 8.53336 2.66347V10.3968C8.53336 10.6913 8.29456 10.9301 8.00003 10.9301C7.70549 10.9301 7.46669 10.6913 7.46669 10.3968V2.66347ZM10.1334 2.93333C10.1334 2.6388 10.3722 2.4 10.6667 2.4C10.9612 2.4 11.2 2.6388 11.2 2.93333V10.0584C11.2 10.3529 10.9612 10.5917 10.6667 10.5917C10.3722 10.5917 10.1334 10.3529 10.1334 10.0584V2.93333ZM14 0H1.99999C0.895465 0 0 0.895467 0 2L5.20832e-05 14C5.20832e-05 15.1045 0.895465 16 1.99999 16H14C15.1045 16 16 15.1045 16 14V2C16 0.895467 15.1045 0 14 0Z" />
    </g>
  ),
})

export const LinearIcon = makeIcon({
  displayName: 'LinearIcon',
  viewBox: 100,
  content: (
    <g>
      <path
        fill="#5E6AD2"
        d="M1.22541 61.5228c-.2225-.9485.90748-1.5459 1.59638-.857L39.3342 97.1782c.6889.6889.0915 1.8189-.857 1.5964C20.0515 94.4522 5.54779 79.9485 1.22541 61.5228ZM.00189135 46.8891c-.01764375.2833.08887215.5599.28957165.7606L52.3503 99.7085c.2007.2007.4773.3075.7606.2896 2.3692-.1476 4.6938-.46 6.9624-.9259.7645-.157 1.0301-1.0963.4782-1.6481L2.57595 39.4485c-.55186-.5519-1.49117-.2863-1.648174.4782-.465915 2.2686-.77832 4.5932-.92588465 6.9624ZM4.21093 29.7054c-.16649.3738-.08169.8106.20765 1.1l64.77602 64.776c.2894.2894.7262.3742 1.1.2077 1.7861-.7956 3.5171-1.6927 5.1855-2.684.5521-.328.6373-1.0867.1832-1.5407L8.43566 24.3367c-.45409-.4541-1.21271-.3689-1.54074.1832-.99132 1.6684-1.88843 3.3994-2.68399 5.1855ZM12.6587 18.074c-.3701-.3701-.393-.9637-.0443-1.3541C21.7795 6.45931 35.1114 0 49.9519 0 77.5927 0 100 22.4073 100 50.0481c0 14.8405-6.4593 28.1724-16.7199 37.3375-.3903.3487-.984.3258-1.3542-.0443L12.6587 18.074Z"
      />
    </g>
  ),
})

export const LinearGreyIcon = makeIcon({
  displayName: 'LinearGreyIcon',
  viewBox: 100,
  content: (
    <g>
      <path
        fill="currentColor"
        d="M1.22541 61.5228c-.2225-.9485.90748-1.5459 1.59638-.857L39.3342 97.1782c.6889.6889.0915 1.8189-.857 1.5964C20.0515 94.4522 5.54779 79.9485 1.22541 61.5228ZM.00189135 46.8891c-.01764375.2833.08887215.5599.28957165.7606L52.3503 99.7085c.2007.2007.4773.3075.7606.2896 2.3692-.1476 4.6938-.46 6.9624-.9259.7645-.157 1.0301-1.0963.4782-1.6481L2.57595 39.4485c-.55186-.5519-1.49117-.2863-1.648174.4782-.465915 2.2686-.77832 4.5932-.92588465 6.9624ZM4.21093 29.7054c-.16649.3738-.08169.8106.20765 1.1l64.77602 64.776c.2894.2894.7262.3742 1.1.2077 1.7861-.7956 3.5171-1.6927 5.1855-2.684.5521-.328.6373-1.0867.1832-1.5407L8.43566 24.3367c-.45409-.4541-1.21271-.3689-1.54074.1832-.99132 1.6684-1.88843 3.3994-2.68399 5.1855ZM12.6587 18.074c-.3701-.3701-.393-.9637-.0443-1.3541C21.7795 6.45931 35.1114 0 49.9519 0 77.5927 0 100 22.4073 100 50.0481c0 14.8405-6.4593 28.1724-16.7199 37.3375-.3903.3487-.984.3258-1.3542-.0443L12.6587 18.074Z"
      />
    </g>
  ),
})

export const TwitterIcon = makeIcon({
  displayName: 'TwitterIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M5.079 14.5c5.944 0 9.196-5.002 9.196-9.34 0-.142 0-.283-.01-.424a6.634 6.634 0 0 0 1.613-1.699c-.59.266-1.216.44-1.857.517a3.285 3.285 0 0 0 1.421-1.816 6.417 6.417 0 0 1-2.052.797 3.22 3.22 0 0 0-1.834-.992 3.192 3.192 0 0 0-2.049.346 3.266 3.266 0 0 0-1.42 1.54 3.333 3.333 0 0 0-.205 2.1 9.065 9.065 0 0 1-3.69-.996 9.204 9.204 0 0 1-2.97-2.434A3.33 3.33 0 0 0 .866 4.49c.186.814.67 1.526 1.355 1.99A3.17 3.17 0 0 1 .755 6.07v.041c0 .758.259 1.493.731 2.08.473.586 1.13.988 1.862 1.138a3.179 3.179 0 0 1-1.46.056 3.285 3.285 0 0 0 1.15 1.632 3.204 3.204 0 0 0 1.87.648 6.422 6.422 0 0 1-4.783 1.36 9.047 9.047 0 0 0 4.954 1.472"
        fill="#1DA1F2"
      />
    </g>
  ),
})

export const TwitterGreyIcon = makeIcon({
  displayName: 'TwitterGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M5.079 14.5c5.944 0 9.196-5.002 9.196-9.34 0-.142 0-.283-.01-.424a6.634 6.634 0 0 0 1.613-1.699c-.59.266-1.216.44-1.857.517a3.285 3.285 0 0 0 1.421-1.816 6.417 6.417 0 0 1-2.052.797 3.22 3.22 0 0 0-1.834-.992 3.192 3.192 0 0 0-2.049.346 3.266 3.266 0 0 0-1.42 1.54 3.333 3.333 0 0 0-.205 2.1 9.065 9.065 0 0 1-3.69-.996 9.204 9.204 0 0 1-2.97-2.434A3.33 3.33 0 0 0 .866 4.49c.186.814.67 1.526 1.355 1.99A3.17 3.17 0 0 1 .755 6.07v.041c0 .758.259 1.493.731 2.08.473.586 1.13.988 1.862 1.138a3.179 3.179 0 0 1-1.46.056 3.285 3.285 0 0 0 1.15 1.632 3.204 3.204 0 0 0 1.87.648 6.422 6.422 0 0 1-4.783 1.36 9.047 9.047 0 0 0 4.954 1.472" />
    </g>
  ),
})

export const VimeoIcon = makeIcon({
  displayName: 'VimeoIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M16 3.2902C15.9262 4.84037 14.8374 6.98109 12.7336 9.69389C10.5559 12.499 8.7105 13.92 7.21569 13.92C6.27451 13.92 5.49942 13.0526 4.85352 11.3363C4.42907 9.74925 3.98616 8.18062 3.56171 6.59354C3.08189 4.87728 2.56517 4.00992 2.01153 4.00992C1.90081 4.00992 1.47636 4.26828 0.756632 4.76655L0 3.80692C0.793541 3.10565 1.56863 2.42284 2.34371 1.72157C3.39562 0.817303 4.18916 0.337488 4.72434 0.282124C5.96078 0.171398 6.73587 1.0203 7.03114 2.82884C7.34487 4.80346 7.56632 6.02146 7.67705 6.50127C8.02768 8.12526 8.43368 8.95571 8.85813 8.95571C9.19031 8.95571 9.68858 8.42053 10.3714 7.36863C11.0358 6.31673 11.4048 5.50473 11.4418 4.9511C11.534 4.04683 11.1834 3.58547 10.3714 3.58547C9.98385 3.58547 9.59631 3.67774 9.19031 3.84383C9.94694 1.26021 11.4602 0.00530778 13.6747 0.0791255C15.3172 0.134489 16.0923 1.20485 16 3.2902Z"
        fill="#1AB7EA"
      />
    </g>
  ),
})

export const VimeoGreyIcon = makeIcon({
  displayName: 'VimeoGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M16 3.2902C15.9262 4.84037 14.8374 6.98109 12.7336 9.69389C10.5559 12.499 8.7105 13.92 7.21569 13.92C6.27451 13.92 5.49942 13.0526 4.85352 11.3363C4.42907 9.74925 3.98616 8.18062 3.56171 6.59354C3.08189 4.87728 2.56517 4.00992 2.01153 4.00992C1.90081 4.00992 1.47636 4.26828 0.756632 4.76655L0 3.80692C0.793541 3.10565 1.56863 2.42284 2.34371 1.72157C3.39562 0.817303 4.18916 0.337488 4.72434 0.282124C5.96078 0.171398 6.73587 1.0203 7.03114 2.82884C7.34487 4.80346 7.56632 6.02146 7.67705 6.50127C8.02768 8.12526 8.43368 8.95571 8.85813 8.95571C9.19031 8.95571 9.68858 8.42053 10.3714 7.36863C11.0358 6.31673 11.4048 5.50473 11.4418 4.9511C11.534 4.04683 11.1834 3.58547 10.3714 3.58547C9.98385 3.58547 9.59631 3.67774 9.19031 3.84383C9.94694 1.26021 11.4602 0.00530778 13.6747 0.0791255C15.3172 0.134489 16.0923 1.20485 16 3.2902Z" />
    </g>
  ),
})

export const YouTubeIcon = makeIcon({
  displayName: 'YouTubeIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M15.67 4.152a2.029 2.029 0 0 0-1.422-1.421C12.998 2.4 8 2.4 8 2.4s-4.998 0-6.248.33A2.029 2.029 0 0 0 .33 4.153C0 5.402 0 8 0 8s0 2.61.33 3.848a2.029 2.029 0 0 0 1.422 1.421C3.002 13.6 8 13.6 8 13.6s5.01 0 6.248-.33a2.029 2.029 0 0 0 1.421-1.422C16 10.598 16 8 16 8s0-2.61-.33-3.848z"
        fill="red"
      />
      <path d="M6.395 10.402L10.56 8 6.395 5.598v4.804z" fill="#fff" />
    </g>
  ),
})

export const YouTubeGreyIcon = makeIcon({
  displayName: 'YouTubeGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.248 2.73a2.029 2.029 0 0 1 1.421 1.422C16 5.39 16 8 16 8s0 2.598-.33 3.848a2.029 2.029 0 0 1-1.422 1.421C13.011 13.6 8 13.6 8 13.6s-4.998 0-6.248-.33A2.029 2.029 0 0 1 .33 11.847C0 10.61 0 8 0 8s0-2.598.33-3.848a2.029 2.029 0 0 1 1.422-1.421C3.002 2.4 8 2.4 8 2.4s4.998 0 6.248.33zM10.56 8l-4.165 2.402V5.598L10.56 8z"
      />
    </g>
  ),
})

// Not via makeIcon: the gradient ids must be unique per instance, because
// url(#) resolves document-wide and picks the first match — with several
// Jira icons mounted (e.g. desktop/mobile variants of one visual), the
// gradient-filled paths of all but the first would reference a possibly
// hidden instance and stop rendering.
export const JiraIcon: Icon = React.memo(function JiraIcon(props: IconProps) {
  const uid = React.useId().replace(/:/g, '')
  const upperGradientId = `jira-upper-${uid}`
  const lowerGradientId = `jira-lower-${uid}`
  return (
    <IconBase viewBoxSize={16} {...props}>
      <path
        d="M8 0a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 15.999 8L16 .7a.7.7 0 0 0-.7-.7H8z"
        fill="#2684FF"
      />
      <path
        d="M4 4a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 12 12L12 4.7a.7.7 0 0 0-.7-.7H4z"
        fill={`url(#${upperGradientId})`}
      />
      <path
        d="M0 8a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 8 16L8 8.7a.7.7 0 0 0-.7-.7H0z"
        fill={`url(#${lowerGradientId})`}
      />
      <defs>
        <linearGradient
          id={upperGradientId}
          x1="11.842"
          y1="4.013"
          x2="8.692"
          y2="7.243"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".18" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
        <linearGradient
          id={lowerGradientId}
          x1="7.842"
          y1="8.013"
          x2="4.692"
          y2="11.243"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".18" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
      </defs>
    </IconBase>
  )
})

export const JiraGreyIcon = makeIcon({
  displayName: 'JiraGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path d="M8 0a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 15.999 8L16 .7a.7.7 0 0 0-.7-.7H8z" />
      <path d="M4 4a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 12 12L12 4.7a.7.7 0 0 0-.7-.7H4z" />
      <path d="M0 8a3.343 3.343 0 0 0 3.343 3.343h1.336v1.336A3.32 3.32 0 0 0 8 16L8 8.7a.7.7 0 0 0-.7-.7H0z" />
    </g>
  ),
})

export const MiroIcon = makeIcon({
  displayName: 'MiroIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fill="#ffd02f"
        d="M14.55 0H1.45C.65 0 0 .65 0 1.45v13.1C0 15.35.65 16 1.45 16h13.1c.8 0 1.45-.65 1.45-1.45V1.45C16 .65 15.35 0 14.55 0z"
      />
      <path
        fill="#050038"
        d="M10.902344 2.132812H9.195312l1.515626 2.351563-3.207032-2.351563H5.796875L7.3125 5.210938 4.109375 2.132812H2.398438l1.492187 3.976563-1.492187 7.757813h1.710937L7.3125 5.546875l-1.515625 8.320313h1.707031l3.207032-9.046876-1.515626 9.046876h1.707032l3.230468-9.9375Zm0 0"
      />
    </g>
  ),
})

export const MiroGreyIcon = makeIcon({
  displayName: 'MiroGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.902344 2.132812H9.195312l1.515626 2.351563-3.207032-2.351563H5.796875L7.3125 5.210938 4.109375 2.132812H2.398438l1.492187 3.976563-1.492187 7.757813h1.710937L7.3125 5.546875l-1.515625 8.320313h1.707031l3.207032-9.046876-1.515626 9.046876h1.707032l3.230468-9.9375Zm0 0"
      />
    </g>
  ),
})

export const OneDriveIcon = makeIcon({
  displayName: 'OneDriveIcon',
  viewBox: 24,
  content: (
    <g>
      <path
        d="m14.5 15 4.95-4.74A7.5 7.5 0 0 0 5.92 8c.08 0 8.58 7 8.58 7Z"
        fill="#0364b8"
      />
      <path
        d="M9.15 8.89A6 6 0 0 0 6 8h-.08a6 6 0 0 0-4.84 9.43l7.42-.93 5.69-4.59Z"
        fill="#0078d4"
      />
      <path
        d="M19.45 10.26h-.32a4.84 4.84 0 0 0-1.94.4l-3 1.26L17.5 16l5.92 1.44a4.88 4.88 0 0 0-4-7.18Z"
        fill="#1490df"
      />
      <path
        d="M1.08 17.43A6 6 0 0 0 6 20h13.13a4.89 4.89 0 0 0 4.29-2.56l-9.23-5.53Z"
        fill="#28a8ea"
      />
    </g>
  ),
})

export const OneDriveGreyIcon = makeIcon({
  displayName: 'OneDriveGreyIcon',
  viewBox: 24,
  content: (
    <g>
      <path
        d="m14.5 15 4.95-4.74A7.5 7.5 0 0 0 5.92 8c.08 0 8.58 7 8.58 7Z"
        fill="currentColor"
      />
      <path
        d="M9.15 8.89A6 6 0 0 0 6 8h-.08a6 6 0 0 0-4.84 9.43l7.42-.93 5.69-4.59Z"
        fill="currentColor"
      />
      <path
        d="M19.45 10.26h-.32a4.84 4.84 0 0 0-1.94.4l-3 1.26L17.5 16l5.92 1.44a4.88 4.88 0 0 0-4-7.18Z"
        fill="currentColor"
      />
      <path
        d="M1.08 17.43A6 6 0 0 0 6 20h13.13a4.89 4.89 0 0 0 4.29-2.56l-9.23-5.53Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const SharepointIcon = makeIcon({
  displayName: 'SharepointIcon',
  viewBox: 16,
  content: (
    <>
      <g>
        <path
          d="M8.18604 8.91428C10.6521 8.91428 12.6512 6.91875 12.6512 4.45714C12.6512 1.99553 10.6521 0 8.18604 0C5.72002 0 3.72092 1.99553 3.72092 4.45714C3.72092 6.91875 5.72002 8.91428 8.18604 8.91428Z"
          fill="#036C70"
        />
        <path
          d="M11.907 12.6286C14.1675 12.6286 16 10.7993 16 8.54287C16 6.28639 14.1675 4.45715 11.907 4.45715C9.64646 4.45715 7.81395 6.28639 7.81395 8.54287C7.81395 10.7993 9.64646 12.6286 11.907 12.6286Z"
          fill="#1A9BA1"
        />
        <path
          d="M8.74418 15.6C10.4909 15.6 11.907 14.1865 11.907 12.4428C11.907 10.6992 10.4909 9.28571 8.74418 9.28571C6.99742 9.28571 5.58139 10.6992 5.58139 12.4428C5.58139 14.1865 6.99742 15.6 8.74418 15.6Z"
          fill="#37C6D0"
        />
        <path
          d="M0.682046 3.71429H7.50399C7.88068 3.71429 8.18604 4.01911 8.18604 4.39512V11.2049C8.18604 11.5809 7.88068 11.8857 7.50399 11.8857H0.682046C0.305362 11.8857 0 11.5809 0 11.2049V4.39512C0 4.01911 0.305362 3.71429 0.682046 3.71429Z"
          fill="url(#sharepoint_gradient)"
        />
        <path
          d="M3.04633 7.7168C2.88649 7.61096 2.75298 7.47007 2.656 7.30488C2.56203 7.13219 2.51519 6.93788 2.52018 6.74142C2.51181 6.47543 2.60173 6.21565 2.77283 6.01156C2.95262 5.80722 3.18502 5.65591 3.44483 5.57402C3.74093 5.47673 4.05107 5.42879 4.36278 5.43214C4.7727 5.41718 5.18204 5.4744 5.57208 5.60114V6.45543C5.40261 6.35294 5.21802 6.27773 5.0251 6.23257C4.81578 6.18133 4.601 6.15563 4.38547 6.15605C4.1582 6.14772 3.93239 6.19544 3.72799 6.29497C3.57018 6.36291 3.46785 6.51788 3.46752 6.68943C3.46688 6.79349 3.50693 6.89369 3.57915 6.96874C3.66446 7.05722 3.76536 7.12924 3.87683 7.1812C4.00086 7.24286 4.18691 7.32482 4.43497 7.42709C4.46228 7.43571 4.4889 7.44639 4.51459 7.45904C4.75874 7.55428 4.99426 7.67022 5.2186 7.80558C5.38848 7.91014 5.53106 8.05348 5.6346 8.2238C5.74075 8.41688 5.7922 8.63517 5.78343 8.85524C5.79555 9.12832 5.71185 9.39707 5.54678 9.61518C5.38225 9.81569 5.16227 9.96346 4.91422 10.0401C4.62247 10.1314 4.31798 10.1755 4.01227 10.1708C3.73799 10.1721 3.4641 10.1497 3.19367 10.104C2.96532 10.0667 2.74248 10.0013 2.53023 9.90934V9.00863C2.73312 9.15327 2.95979 9.26138 3.2 9.32806C3.43939 9.40253 3.68825 9.4423 3.93897 9.44618C4.17102 9.46085 4.40266 9.41178 4.60874 9.30429C4.7531 9.22297 4.8409 9.06895 4.83721 8.90352C4.83817 8.78841 4.79256 8.67779 4.7107 8.59672C4.6089 8.49696 4.49104 8.41498 4.36205 8.35418C4.21321 8.27989 3.99405 8.18196 3.70456 8.06037C3.47426 7.96795 3.25376 7.85286 3.04633 7.7168Z"
          fill="white"
        />
      </g>
      <linearGradient
        id="sharepoint_gradient"
        x1="1.42208"
        y1="3.18231"
        x2="6.74965"
        y2="12.426"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#058F92" />
        <stop offset="0.5" stopColor="#038489" />
        <stop offset="1" stopColor="#026D71" />
      </linearGradient>
    </>
  ),
})

export const HubspotIcon = makeIcon({
  displayName: 'HubspotIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M11.7311 5.26612V3.36069C12.2448 3.12059 12.5743 2.60571 12.5777 2.03861V1.99453C12.5777 1.18327 11.9197 0.525518 11.1084 0.525518H11.0656C10.2543 0.525518 9.59656 1.18327 9.59656 1.99453V2.03861C9.59869 2.31725 9.68003 2.58955 9.8311 2.8237C9.98216 3.05785 10.1967 3.2442 10.4497 3.361V5.26612C9.72661 5.37648 9.04353 5.67816 8.47425 6.13646L3.24752 2.06831C3.28472 1.93419 3.30473 1.79539 3.3066 1.65658V1.65315C3.3066 0.740289 2.56631 0 1.65315 0C0.740289 0 0 0.740289 0 1.65315C0 2.56538 0.739039 3.30535 1.65096 3.3066C1.93763 3.3041 2.21868 3.22564 2.46565 3.08058L7.61204 7.08433C7.16048 7.76688 6.91957 8.56714 6.91927 9.38554C6.91927 10.2418 7.18374 11.079 7.67519 11.7796L6.1102 13.3446C5.98405 13.3072 5.85318 13.2882 5.72161 13.288C4.97257 13.288 4.36546 13.8951 4.36546 14.6438C4.36546 15.3929 4.97257 16 5.72161 16C6.47034 16 7.07745 15.3929 7.07745 14.6438V14.6398C7.07636 14.5071 7.05507 14.3753 7.0143 14.249L8.56241 12.6996C9.29302 13.2625 10.1893 13.5678 11.1115 13.5681C13.4174 13.5681 15.2872 11.6983 15.2872 9.39242C15.2872 7.32755 13.7773 5.57218 11.7355 5.26393L11.7311 5.26612ZM11.0937 11.5311C9.94357 11.4835 9.03509 10.5372 9.03509 9.38585C9.03509 8.27823 9.87823 7.35193 10.9805 7.24814H11.0937C12.2129 7.33349 13.0776 8.26667 13.0776 9.38898C13.0776 10.5116 12.2129 11.4448 11.094 11.5298L11.0937 11.5311Z"
        fill="#FF7A59"
      />
    </g>
  ),
})

export const HubspotGreyIcon = makeIcon({
  displayName: 'HubspotGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fill="currentColor"
        d="M11.7311 5.26612V3.36069C12.2448 3.12059 12.5743 2.60571 12.5777 2.03861V1.99453C12.5777 1.18327 11.9197 0.525518 11.1084 0.525518H11.0656C10.2543 0.525518 9.59656 1.18327 9.59656 1.99453V2.03861C9.59869 2.31725 9.68003 2.58955 9.8311 2.8237C9.98216 3.05785 10.1967 3.2442 10.4497 3.361V5.26612C9.72661 5.37648 9.04353 5.67816 8.47425 6.13646L3.24752 2.06831C3.28472 1.93419 3.30473 1.79539 3.3066 1.65658V1.65315C3.3066 0.740289 2.56631 0 1.65315 0C0.740289 0 0 0.740289 0 1.65315C0 2.56538 0.739039 3.30535 1.65096 3.3066C1.93763 3.3041 2.21868 3.22564 2.46565 3.08058L7.61204 7.08433C7.16048 7.76688 6.91957 8.56714 6.91927 9.38554C6.91927 10.2418 7.18374 11.079 7.67519 11.7796L6.1102 13.3446C5.98405 13.3072 5.85318 13.2882 5.72161 13.288C4.97257 13.288 4.36546 13.8951 4.36546 14.6438C4.36546 15.3929 4.97257 16 5.72161 16C6.47034 16 7.07745 15.3929 7.07745 14.6438V14.6398C7.07636 14.5071 7.05507 14.3753 7.0143 14.249L8.56241 12.6996C9.29302 13.2625 10.1893 13.5678 11.1115 13.5681C13.4174 13.5681 15.2872 11.6983 15.2872 9.39242C15.2872 7.32755 13.7773 5.57218 11.7355 5.26393L11.7311 5.26612ZM11.0937 11.5311C9.94357 11.4835 9.03509 10.5372 9.03509 9.38585C9.03509 8.27823 9.87823 7.35193 10.9805 7.24814H11.0937C12.2129 7.33349 13.0776 8.26667 13.0776 9.38898C13.0776 10.5116 12.2129 11.4448 11.094 11.5298L11.0937 11.5311Z"
      />
    </g>
  ),
})

export const GitIcon = makeIcon({
  displayName: 'GitIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M15.2924 7.32504L8.6748 0.707802C8.29377 0.326607 7.67571 0.326607 7.29435 0.707802L5.92033 2.08215L7.66334 3.82516C8.06845 3.68826 8.53295 3.78013 8.85575 4.1031C9.18054 4.42805 9.27159 4.8965 9.13122 5.3031L10.8114 6.9831C11.218 6.8429 11.6868 6.93362 12.0114 7.25873C12.465 7.71234 12.465 8.44735 12.0114 8.90129C11.5574 9.35506 10.8224 9.35506 10.3683 8.90129C10.0272 8.55984 9.94276 8.0584 10.1158 7.63811L8.54878 6.07127V10.1945C8.6593 10.2492 8.76371 10.3222 8.85575 10.4142C9.30936 10.8678 9.30936 11.6028 8.85575 12.0569C8.40214 12.5104 7.66664 12.5104 7.21336 12.0569C6.75975 11.6026 6.75975 10.8676 7.21336 10.4142C7.32553 10.3022 7.45534 10.2174 7.5939 10.1607V5.99902C7.45534 5.94228 7.32586 5.85832 7.21336 5.74549C6.86977 5.40207 6.78713 4.89766 6.9633 4.47572L5.24503 2.75712L0.707299 7.29436C0.326103 7.67589 0.326103 8.29395 0.707299 8.67514L7.3252 15.2925C7.70623 15.6737 8.32412 15.6737 8.70565 15.2925L15.2924 8.70582C15.6736 8.32463 15.6736 7.70624 15.2924 7.32504Z"
        fill="#F05133"
      />
    </g>
  ),
})

export const GitGreyIcon = makeIcon({
  displayName: 'GitGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fill="currentColor"
        d="M15.2924 7.32504L8.6748 0.707802C8.29377 0.326607 7.67571 0.326607 7.29435 0.707802L5.92033 2.08215L7.66334 3.82516C8.06845 3.68826 8.53295 3.78013 8.85575 4.1031C9.18054 4.42805 9.27159 4.8965 9.13122 5.3031L10.8114 6.9831C11.218 6.8429 11.6868 6.93362 12.0114 7.25873C12.465 7.71234 12.465 8.44735 12.0114 8.90129C11.5574 9.35506 10.8224 9.35506 10.3683 8.90129C10.0272 8.55984 9.94276 8.0584 10.1158 7.63811L8.54878 6.07127V10.1945C8.6593 10.2492 8.76371 10.3222 8.85575 10.4142C9.30936 10.8678 9.30936 11.6028 8.85575 12.0569C8.40214 12.5104 7.66664 12.5104 7.21336 12.0569C6.75975 11.6026 6.75975 10.8676 7.21336 10.4142C7.32553 10.3022 7.45534 10.2174 7.5939 10.1607V5.99902C7.45534 5.94228 7.32586 5.85832 7.21336 5.74549C6.86977 5.40207 6.78713 4.89766 6.9633 4.47572L5.24503 2.75712L0.707299 7.29436C0.326103 7.67589 0.326103 8.29395 0.707299 8.67514L7.3252 15.2925C7.70623 15.6737 8.32412 15.6737 8.70565 15.2925L15.2924 8.70582C15.6736 8.32463 15.6736 7.70624 15.2924 7.32504Z"
      />
    </g>
  ),
})

export const AttioIcon = makeIcon({
  displayName: 'AttioIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M15.8424 11.048L14.5025 8.94199L14.3711 8.75999C14.1609 8.44799 13.8194 8.26599 13.4516 8.26599L11.2972 8.23999L11.1658 8.49999L8.59113 12.582L8.45977 12.816L9.53695 14.532C9.74713 14.844 10.0887 15.026 10.4565 15.026H13.4778C13.8456 15.026 14.2135 14.844 14.3974 14.532L14.5025 14.376L15.8424 12.244C16.0525 11.854 16.0525 11.412 15.8424 11.048ZM15.422 11.958L14.0821 14.09C14.0821 14.09 14.0821 14.116 14.0558 14.116C14.0033 14.168 13.9507 14.168 13.9245 14.168C13.8982 14.168 13.8194 14.168 13.7668 14.09L12.4269 11.958C12.4007 11.932 12.4007 11.906 12.3744 11.88C12.3744 11.854 12.3481 11.828 12.3481 11.802C12.3218 11.698 12.3218 11.594 12.3481 11.464C12.3744 11.412 12.3744 11.36 12.4269 11.308L13.7668 9.20199C13.7931 9.14999 13.8456 9.12399 13.8719 9.12399C13.8982 9.12399 13.8982 9.12399 13.8982 9.12399C13.8982 9.12399 13.8982 9.12399 13.9245 9.12399C13.9507 9.12399 14.0296 9.12399 14.0821 9.20199L15.422 11.308C15.5534 11.516 15.5534 11.75 15.422 11.958Z"
        fill="var(--shade-00)"
      />
      <path
        d="M11.8752 5.926C12.0854 5.588 12.0854 5.12 11.8752 4.782L10.5353 2.676L10.4302 2.494C10.22 2.182 9.87849 2 9.51067 2H6.48933C6.12151 2 5.77997 2.182 5.56979 2.494L0.157635 11.074C0.0525452 11.23 0 11.438 0 11.62C0 11.828 0.0525452 12.01 0.157635 12.192L1.60263 14.48C1.81281 14.818 2.15435 15 2.54844 15H5.56979C5.9376 15 6.30542 14.818 6.48933 14.506L6.59442 14.324L7.67159 12.608L10.8506 7.564L11.8752 5.926ZM11.5599 5.38C11.5599 5.484 11.5337 5.588 11.4548 5.692L6.17406 14.064C6.12151 14.142 6.04269 14.142 6.01642 14.142C5.99015 14.142 5.91133 14.142 5.85878 14.064L4.51888 11.932C4.38752 11.75 4.38752 11.49 4.51888 11.308L9.82594 2.936C9.87849 2.858 9.95731 2.858 9.98358 2.858C10.0099 2.858 10.0887 2.858 10.1412 2.936L11.4811 5.042C11.5337 5.146 11.5599 5.25 11.5599 5.38Z"
        fill="var(--shade-00)"
      />
    </g>
  ),
})

export const AttioGreyIcon = makeIcon({
  displayName: 'AttioGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M15.8424 11.048L14.5025 8.94199L14.3711 8.75999C14.1609 8.44799 13.8194 8.26599 13.4516 8.26599L11.2972 8.23999L11.1658 8.49999L8.59113 12.582L8.45977 12.816L9.53695 14.532C9.74713 14.844 10.0887 15.026 10.4565 15.026H13.4778C13.8456 15.026 14.2135 14.844 14.3974 14.532L14.5025 14.376L15.8424 12.244C16.0525 11.854 16.0525 11.412 15.8424 11.048ZM15.422 11.958L14.0821 14.09C14.0821 14.09 14.0821 14.116 14.0558 14.116C14.0033 14.168 13.9507 14.168 13.9245 14.168C13.8982 14.168 13.8194 14.168 13.7668 14.09L12.4269 11.958C12.4007 11.932 12.4007 11.906 12.3744 11.88C12.3744 11.854 12.3481 11.828 12.3481 11.802C12.3218 11.698 12.3218 11.594 12.3481 11.464C12.3744 11.412 12.3744 11.36 12.4269 11.308L13.7668 9.20199C13.7931 9.14999 13.8456 9.12399 13.8719 9.12399C13.8982 9.12399 13.8982 9.12399 13.8982 9.12399C13.8982 9.12399 13.8982 9.12399 13.9245 9.12399C13.9507 9.12399 14.0296 9.12399 14.0821 9.20199L15.422 11.308C15.5534 11.516 15.5534 11.75 15.422 11.958Z"
        fill="currentColor"
      />
      <path
        d="M11.8752 5.926C12.0854 5.588 12.0854 5.12 11.8752 4.782L10.5353 2.676L10.4302 2.494C10.22 2.182 9.87849 2 9.51067 2H6.48933C6.12151 2 5.77997 2.182 5.56979 2.494L0.157635 11.074C0.0525452 11.23 0 11.438 0 11.62C0 11.828 0.0525452 12.01 0.157635 12.192L1.60263 14.48C1.81281 14.818 2.15435 15 2.54844 15H5.56979C5.9376 15 6.30542 14.818 6.48933 14.506L6.59442 14.324L7.67159 12.608L10.8506 7.564L11.8752 5.926ZM11.5599 5.38C11.5599 5.484 11.5337 5.588 11.4548 5.692L6.17406 14.064C6.12151 14.142 6.04269 14.142 6.01642 14.142C5.99015 14.142 5.91133 14.142 5.85878 14.064L4.51888 11.932C4.38752 11.75 4.38752 11.49 4.51888 11.308L9.82594 2.936C9.87849 2.858 9.95731 2.858 9.98358 2.858C10.0099 2.858 10.0887 2.858 10.1412 2.936L11.4811 5.042C11.5337 5.146 11.5599 5.25 11.5599 5.38Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const GmailIcon = makeIcon({
  displayName: 'GmailIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fill="#4285F4"
        d="M1.09 14h2.546V7.818L0 5.091v7.818C0 13.513.49 14 1.09 14"
      />
      <path
        fill="#34A853"
        d="M12.364 14h2.545c.604 0 1.091-.49 1.091-1.09V5.09l-3.636 2.728"
      />
      <path
        fill="#FBBC04"
        d="M12.364 3.09v4.728L16 5.091V3.636c0-1.349-1.54-2.118-2.618-1.309"
      />
      <path
        fill="#EA4335"
        d="M3.636 7.818V3.091L8 6.364l4.364-3.273v4.727L8 11.091"
      />
      <path
        fill="#C5221F"
        d="M0 3.636v1.455l3.636 2.727V3.091l-1.018-.764C1.538 1.518 0 2.287 0 3.637"
      />
    </g>
  ),
})

export const BlueskyIcon = makeIcon({
  displayName: 'BlueskyIcon',
  viewBox: 16,
  content: (
    <path
      d="M3.46821 1.94827C5.30257 3.3254 7.27564 6.11763 8.00005 7.6161C8.72451 6.11774 10.6975 3.32537 12.5319 1.94827C13.8555 0.954596 16 0.185745 16 2.63227C16 3.12087 15.7199 6.7368 15.5556 7.32383C14.9844 9.36475 12.9033 9.8853 11.0521 9.57024C14.288 10.121 15.1111 11.9452 13.3334 13.7694C9.95717 17.2339 8.48076 12.9001 8.10228 11.7896C8.03293 11.5861 8.00048 11.4908 8 11.5718C7.99952 11.4908 7.96707 11.5861 7.89772 11.7896C7.5194 12.9001 6.04303 17.234 2.66658 13.7694C0.888822 11.9452 1.71196 10.1209 4.94786 9.57024C3.09662 9.8853 1.01547 9.36475 0.444439 7.32383C0.280131 6.73674 0 3.12082 0 2.63227C0 0.185745 2.14459 0.954596 3.46812 1.94827H3.46821Z"
      fill="#1185FE"
    />
  ),
})

export const BlueskyGreyIcon = makeIcon({
  displayName: 'BlueskyGreyIcon',
  viewBox: 16,
  content: (
    <path
      d="M3.46821 1.94827C5.30257 3.3254 7.27564 6.11763 8.00005 7.6161C8.72451 6.11774 10.6975 3.32537 12.5319 1.94827C13.8555 0.954596 16 0.185745 16 2.63227C16 3.12087 15.7199 6.7368 15.5556 7.32383C14.9844 9.36475 12.9033 9.8853 11.0521 9.57024C14.288 10.121 15.1111 11.9452 13.3334 13.7694C9.95717 17.2339 8.48076 12.9001 8.10228 11.7896C8.03293 11.5861 8.00048 11.4908 8 11.5718C7.99952 11.4908 7.96707 11.5861 7.89772 11.7896C7.5194 12.9001 6.04303 17.234 2.66658 13.7694C0.888822 11.9452 1.71196 10.1209 4.94786 9.57024C3.09662 9.8853 1.01547 9.36475 0.444439 7.32383C0.280131 6.73674 0 3.12082 0 2.63227C0 0.185745 2.14459 0.954596 3.46812 1.94827H3.46821Z"
      fill="currentColor"
    />
  ),
})

export const DustIcon = makeIcon({
  displayName: 'DustIcon',
  viewBox: 48,
  content: (
    <g clip-path="url(#clip0_5641_63234)">
      <path d="M0.5 1.15398e-05H12.5V24H0.5V1.15398e-05Z" fill="#D8DADF" />
      <path
        d="M48.5 1.04907e-06V12L24.5 12V0L48.5 1.04907e-06Z"
        fill="#D8DADF"
      />
      <path
        d="M24.5 12C24.5 18.6274 19.1274 24 12.5 24V1.15398e-05C19.1274 1.15398e-05 24.5 5.37258 24.5 12Z"
        fill="white"
      />
      <path
        d="M36.5 24C29.8726 24 24.5 18.6274 24.5 12L48.5 12C48.5 18.6274 43.1274 24 36.5 24Z"
        fill="white"
      />
      <path
        d="M0.5 36H12.5C15.8137 36 18.5 38.6863 18.5 42C18.5 45.3137 15.8137 48 12.5 48H0.5V36Z"
        fill="white"
      />
      <path
        d="M48.5 36H12.5C9.18629 36 6.5 33.3137 6.5 30C6.5 26.6863 9.18629 24 12.5 24L48.5 24V36Z"
        fill="#D8DADF"
      />
      <path d="M24.5 36H36.5V48H24.5V36Z" fill="white" />
    </g>
  ),
})

export const GuruIcon = makeIcon({
  displayName: 'GuruIcon',
  viewBox: 48,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.9922 28.4767C48.1611 34.4532 45.5705 38.9234 40.4738 41.7899C33.4033 45.7699 25.8198 48.1559 17.6131 47.893C12.9871 47.7436 9.28955 45.5232 6.86454 41.6568C2.21905 34.2519 -0.277376 26.1328 0.0245322 17.3418C0.183602 12.7255 2.56965 9.09612 6.46524 6.71332C13.8019 2.22365 21.7944 -0.266282 30.4556 0.0226406C35.1498 0.178464 38.7727 2.61321 41.2399 6.54451C45.4439 13.2417 47.4014 20.6595 47.9955 28.4767H47.9922ZM27.3101 32.9956C25.4597 33.6709 23.4762 33.7845 21.7265 33.317C17.3764 32.1483 14.2177 28.1489 14.2177 23.8053C14.2177 20.3447 15.776 18.0788 17.081 16.7867C18.8794 15.011 21.3759 13.9559 23.7846 13.9559H23.8755C28.4658 14.0046 31.3745 17.475 31.4005 17.5074C31.7998 17.9976 32.5173 18.069 33.0075 17.673C33.4976 17.2737 33.5723 16.5562 33.173 16.066C33.0302 15.8875 29.5858 11.7354 23.9015 11.6738C20.8305 11.6575 17.753 12.9139 15.4773 15.1636C13.1951 17.423 11.9355 20.4908 11.9355 23.8053C11.9355 29.1617 15.8052 34.0897 21.1356 35.5213C22.0381 35.7648 22.9828 35.8849 23.9437 35.8849C25.3299 35.8849 26.7453 35.6349 28.0958 35.1415C31.6083 33.8559 35.0364 30.4797 34.913 26.5777C34.1404 27.1458 33.2964 27.6652 32.4069 28.1521C31.7219 30.2979 29.5631 32.1743 27.3134 32.9956H27.3101ZM33.4645 23.2307C34.9319 22.1757 35.9155 21.1239 35.935 21.1012V21.0979C36.3635 20.6337 37.0874 20.6045 37.5484 21.033C38.0126 21.4615 38.0418 22.1822 37.6133 22.6464L37.6131 22.6467C37.5174 22.749 36.3946 23.9491 34.6916 25.1526C34.3637 25.3863 33.6366 25.8992 32.6205 26.4154C31.1661 27.1588 29.504 27.7107 27.8029 27.6685C24.7514 27.6035 23.6411 25.9219 23.6152 24.3702C23.6022 23.5067 23.9008 22.7405 24.4754 22.1562C25.2091 21.4128 26.3129 21.0362 27.751 21.0362C29.5072 21.0362 31.9387 21.7439 33.4645 23.2307ZM25.9006 24.3377C25.9136 25.172 26.9686 25.3701 27.8516 25.3896C29.0885 25.4155 30.2864 25.0325 31.3966 24.4871C30.361 23.7469 28.871 23.3184 27.751 23.3184C26.6959 23.3184 26.2674 23.5943 26.1051 23.7599C26.0531 23.8118 25.8941 23.9742 25.9006 24.3377Z"
      fill="currentColor"
    />
  ),
})

export const GleanIcon = makeIcon({
  displayName: 'GleanIcon',
  viewBox: 32,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0942 3.83196L22.102 0L25.7518 2.83837L22.766 6.64223C24.3073 8.4768 25.235 10.8397 25.235 13.4183C25.235 19.2554 20.4812 23.9872 14.617 23.9872C8.75286 23.9872 3.99902 19.2554 3.99902 13.4183C3.99902 7.58114 8.75286 2.84926 14.617 2.84926C16.2167 2.84926 17.7337 3.20136 19.0942 3.83196ZM14.617 19.448C11.2714 19.448 8.55924 16.7484 8.55924 13.4183C8.55924 10.0881 11.2714 7.38842 14.617 7.38842C17.9627 7.38842 20.6748 10.0881 20.6748 13.4183C20.6748 16.7484 17.9627 19.448 14.617 19.448ZM25.3585 22.4598C25.0955 22.7698 24.8184 23.0658 24.5291 23.3538C24.2399 23.6397 23.9384 23.9136 23.6249 24.1733C23.3134 24.433 22.9896 24.6786 22.6538 24.9102C22.3201 25.1419 21.9742 25.3612 21.6201 25.5627C21.2681 25.7661 20.9061 25.9512 20.5359 26.1224C20.1677 26.2935 19.7914 26.4487 19.4071 26.5856C19.0247 26.7244 18.6363 26.8453 18.2398 26.948C17.8494 27.0546 17.4509 27.1413 17.0484 27.2098C16.6498 27.2801 16.2452 27.3326 15.8366 27.3668C15.4341 27.4011 15.0275 27.4191 14.6168 27.4191C14.2062 27.4191 13.7996 27.4011 13.397 27.3668C12.9884 27.3326 12.5838 27.2801 12.1853 27.2098C11.7827 27.1413 11.3842 27.0546 10.9938 26.948L9.80227 31.3738C10.3201 31.5127 10.8501 31.6296 11.3862 31.7222C11.9142 31.8149 12.4523 31.8852 12.9965 31.9297C13.5305 31.9758 14.0706 32 14.6168 32C15.163 32 15.7031 31.9758 16.2372 31.9297C16.7813 31.8852 17.3174 31.8149 17.8474 31.7222C18.3835 31.6296 18.9115 31.5127 19.4313 31.3738C19.9573 31.2368 20.4752 31.0759 20.981 30.8906C21.4928 30.7073 21.9925 30.5019 22.4819 30.2744C22.9735 30.0469 23.4549 29.7992 23.9223 29.5313C24.3915 29.2616 24.8488 28.9717 25.2917 28.6615C25.7368 28.3534 26.1677 28.0273 26.5824 27.6809C26.9991 27.3346 27.3997 26.9722 27.7819 26.5916C28.1663 26.2111 28.5324 25.8163 28.8824 25.4036C29.2324 24.9928 29.5642 24.564 29.8757 24.1229L26.107 21.4953C25.8723 21.8274 25.6215 22.1497 25.3585 22.4598Z"
      fill="currentColor"
    />
  ),
})

export const ZendeskIcon = makeIcon({
  displayName: 'ZendeskIcon',
  viewBox: 16,
  content: (
    <path
      fill="#16140C"
      d="M7.397 13.97H.085l7.312-8.808v8.808ZM12.259 10.321a3.65 3.65 0 0 1 3.655 3.648H8.603a3.652 3.652 0 0 1 3.656-3.648ZM8.603 10.809V2h7.312l-7.312 8.809ZM7.397 2a3.652 3.652 0 0 1-3.656 3.648A3.652 3.652 0 0 1 .085 2h7.312Z"
    />
  ),
})

export const ZendeskGreyIcon = makeIcon({
  displayName: 'ZendeskGreyIcon',
  viewBox: 16,
  content: (
    <path
      fill="currentColor"
      d="M7.397 13.97H.085l7.312-8.808v8.808ZM12.259 10.321a3.65 3.65 0 0 1 3.655 3.648H8.603a3.652 3.652 0 0 1 3.656-3.648ZM8.603 10.809V2h7.312l-7.312 8.809ZM7.397 2a3.652 3.652 0 0 1-3.656 3.648A3.652 3.652 0 0 1 .085 2h7.312Z"
    />
  ),
})

export const ZoomIcon = makeIcon({
  displayName: 'ZoomIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M0 5.48571C0 3.56554 0 2.60545 0.373691 1.87203C0.7024 1.2269 1.2269 0.7024 1.87203 0.373691C2.60545 0 3.56554 0 5.48571 0H10.5143C12.4345 0 13.3946 0 14.1279 0.373691C14.7731 0.7024 15.2976 1.2269 15.6263 1.87203C16 2.60545 16 3.56554 16 5.48571V10.5143C16 12.4345 16 13.3946 15.6263 14.1279C15.2976 14.7731 14.7731 15.2976 14.1279 15.6263C13.3946 16 12.4345 16 10.5143 16H5.48571C3.56554 16 2.60545 16 1.87203 15.6263C1.2269 15.2976 0.7024 14.7731 0.373691 14.1279C0 13.3946 0 12.4345 0 10.5143V5.48571Z"
        fill="#4087FC"
      />
      <path
        d="M3.58096 4.57144C3.18121 4.57144 2.85715 4.93693 2.85715 5.38778V9.34693C2.85715 10.4966 3.6835 11.4286 4.70286 11.4286L8.99046 11.3878C9.39023 11.3878 9.71429 11.0223 9.71429 10.5714V6.57144C9.71429 5.42178 8.73366 4.57144 7.71429 4.57144H3.58096Z"
        fill="white"
      />
      <path
        d="M10.6927 6.13007C10.4341 6.38584 10.2857 6.75492 10.2857 7.14287V8.79961C10.2857 9.18755 10.4341 9.55669 10.6927 9.81241L12.3022 11.23C12.6297 11.5538 13.1429 11.2915 13.1429 10.8003V5.22012C13.1429 4.72887 12.6297 4.4666 12.3022 4.79041L10.6927 6.13007Z"
        fill="white"
      />
    </g>
  ),
})

export const ZoomGreyIcon = makeIcon({
  displayName: 'ZoomGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        d="M10.5146 0C12.4346 1.47958e-09 13.3946 0.000355513 14.1279 0.374023C14.773 0.70272 15.2973 1.22702 15.626 1.87207C15.9997 2.60544 16 3.56542 16 5.48535V10.5146C16 12.4346 15.9997 13.3946 15.626 14.1279C15.2973 14.773 14.773 15.2973 14.1279 15.626C13.3946 15.9997 12.4346 16 10.5146 16H5.48535C3.56542 16 2.60544 15.9997 1.87207 15.626C1.22702 15.2973 0.70272 14.773 0.374023 14.1279C0.000355513 13.3946 1.47958e-09 12.4346 0 10.5146V5.48535C1.48541e-09 3.56542 0.000355559 2.60544 0.374023 1.87207C0.702717 1.22702 1.22702 0.702717 1.87207 0.374023C2.60544 0.000355559 3.56542 1.48541e-09 5.48535 0H10.5146ZM3.58105 4.57129C3.18133 4.57129 2.85746 4.93687 2.85742 5.3877V9.34668C2.85742 10.4963 3.68376 11.4287 4.70312 11.4287L8.99023 11.3877C9.39001 11.3877 9.71387 11.0221 9.71387 10.5713V6.57129C9.71379 5.4217 8.7332 4.57129 7.71387 4.57129H3.58105ZM13.1426 5.21973C13.1423 4.72873 12.6292 4.46632 12.3018 4.79004L10.6924 6.12988C10.4339 6.38559 10.2862 6.75477 10.2861 7.14258V8.7998C10.2862 9.18762 10.4339 9.55683 10.6924 9.8125L12.3018 11.2305C12.6291 11.5541 13.1422 11.2917 13.1426 10.8008V5.21973Z"
        fill="currentColor"
      />
    </g>
  ),
})

export const ClaudeIcon = makeIcon({
  displayName: 'ClaudeIcon',
  viewBox: 24,
  content: (
    <path
      d="M4.70886 15.9144L9.42987 13.2741L9.50886 13.044L9.42987 12.9168H9.19899L8.40911 12.8684L5.71139 12.7957L3.37215 12.6988L1.10582 12.5777L0.534684 12.4566L0 11.7541L0.0546835 11.4029L0.534684 11.0819L1.22127 11.1425L2.74025 11.2454L5.01873 11.4029L6.67139 11.4998L9.12 11.7541H9.50886L9.56354 11.5967L9.42987 11.4998L9.32658 11.4029L6.96911 9.81023L4.41721 8.12674L3.08051 7.15783L2.35747 6.66732L1.99291 6.20709L1.83494 5.20184L2.49114 4.48122L3.37215 4.54177L3.59696 4.60233L4.49013 5.28662L6.39797 6.75816L8.88911 8.58698L9.25367 8.88976L9.39949 8.78681L9.41772 8.71415L9.25367 8.44164L7.89873 6.00119L6.45266 3.51836L5.80861 2.48889L5.63848 1.87121C5.57772 1.61687 5.53519 1.40492 5.53519 1.14453L6.28253 0.133225L6.6957 0L7.69215 0.133225L8.11139 0.496567L8.73114 1.90754L9.73367 4.12998L11.2891 7.15178L11.7448 8.04802L11.9878 8.87765L12.079 9.13199H12.237V8.98665L12.3646 7.285L12.6015 5.19579L12.8324 2.50706L12.9114 1.7501L13.2881 0.841742L14.0354 0.35123L14.6187 0.629792L15.0987 1.31409L15.0319 1.75615L14.7463 3.60314L14.1873 6.49776L13.8228 8.43559H14.0354L14.2785 8.19336L15.2628 6.89138L16.9154 4.83245L17.6446 4.01493L18.4952 3.11263L19.042 2.68267H20.0749L20.8344 3.80903L20.4942 4.97173L19.4309 6.31609L18.5499 7.45456L17.2861 9.15016L16.4962 10.5066L16.5691 10.6156L16.7575 10.5975L19.6132 9.9919L21.1565 9.71334L22.9975 9.39844L23.8299 9.78601L23.921 10.1796L23.5929 10.985L21.6243 11.4695L19.3154 11.9297L15.8765 12.7412L15.8339 12.7715L15.8825 12.832L17.4319 12.9774L18.0942 13.0137H19.7165L22.7362 13.2378L23.5261 13.7585L24 14.3944L23.921 14.8788L22.7058 15.4965L21.0653 15.109L17.2375 14.2006L15.9251 13.8736H15.7428V13.9826L16.8365 15.0484L18.8415 16.853L21.3509 19.1784L21.4785 19.7537L21.1565 20.2079L20.8162 20.1594L18.6106 18.5062L17.76 17.7614L15.8339 16.1445H15.7063V16.314L16.1499 16.962L18.4952 20.4743L18.6167 21.5522L18.4466 21.9035L17.839 22.1154L17.1706 21.9943L15.7975 20.0746L14.3818 17.9127L13.2395 15.9749L13.0997 16.0536L12.4253 23.2902L12.1094 23.6596L11.3803 23.9382L10.7727 23.4779L10.4506 22.7331L10.7727 21.2615L11.1615 19.3419L11.4775 17.8159L11.763 15.9204L11.9332 15.2906L11.921 15.2482L11.7813 15.2664L10.3473 17.2285L8.16608 20.1655L6.44051 22.0064L6.02734 22.1699L5.31038 21.8005L5.37722 21.1404L5.77823 20.553L8.16608 17.5252L9.60608 15.6479L10.5357 14.5639L10.5296 14.4065H10.4749L4.13165 18.5123L3.00152 18.6576L2.51544 18.2034L2.5762 17.4586L2.80709 17.2163L4.71494 15.9083L4.70886 15.9144Z"
      fill="#D97757"
    />
  ),
})

export const ClaudeGreyIcon = makeIcon({
  displayName: 'ClaudeGreyIcon',
  viewBox: 16,
  content: (
    <path d="M3.13924 10.6302L6.28658 8.87002L6.33924 8.71661L6.28658 8.63183H6.13266L5.60608 8.59953L3.80759 8.55109L2.2481 8.48649L0.737215 8.40575L0.356456 8.32501L0 7.8567L0.0364557 7.62255L0.356456 7.40858L0.814177 7.44895L1.82684 7.51758L3.34582 7.62255L4.44759 7.68714L6.08 7.8567H6.33924L6.3757 7.75174L6.28658 7.68714L6.21772 7.62255L4.64608 6.56078L2.94481 5.43846L2.05367 4.79252L1.57165 4.46551L1.32861 4.15869L1.22329 3.48853L1.66076 3.00811L2.2481 3.04848L2.39797 3.08885L2.99342 3.54505L4.26532 4.52607L5.92608 5.74528L6.16911 5.94714L6.26633 5.87851L6.27848 5.83006L6.16911 5.64839L5.26582 4.02143L4.30177 2.3662L3.87241 1.67989L3.75899 1.2681C3.71848 1.09854 3.69013 0.957244 3.69013 0.783648L4.18835 0.109447L4.4638 0.0206299L5.1281 0.109447L5.4076 0.351675L5.82076 1.29233L6.48911 2.77395L7.52608 4.78848L7.82987 5.38598L7.9919 5.93906L8.05266 6.10862H8.15797V6.01173L8.24304 4.8773L8.40101 3.48449L8.55494 1.692L8.6076 1.18736L8.85874 0.581791L9.35696 0.254783L9.74582 0.440491L10.0658 0.896687L10.0213 1.1914L9.83089 2.42272L9.45823 4.35247L9.21519 5.64435H9.35696L9.51899 5.48287L10.1752 4.61488L11.277 3.24226L11.763 2.69725L12.3301 2.09572L12.6947 1.80908H13.3833L13.8896 2.55999L13.6628 3.33511L12.9539 4.23136L12.3666 4.99034L11.5241 6.12073L10.9975 7.02505L11.0461 7.09772L11.1716 7.08561L13.0754 6.6819L14.1043 6.49619L15.3316 6.28626L15.8866 6.54463L15.9473 6.80705L15.7286 7.34399L14.4162 7.66696L12.877 7.97378L10.5843 8.51475L10.5559 8.53494L10.5884 8.57531L11.6213 8.6722L12.0628 8.69642H13.1443L15.1575 8.8458L15.6841 9.19299L16 9.61689L15.9473 9.93986L15.1372 10.3516L14.0435 10.0933L11.4916 9.4877L10.6167 9.2697H10.4952V9.34237L11.2243 10.0529L12.561 11.256L14.2339 12.8062L14.319 13.1897L14.1043 13.4925L13.8775 13.4602L12.4071 12.3581L11.84 11.8615L10.5559 10.7836H10.4709V10.8967L10.7666 11.3286L12.3301 13.6702L12.4111 14.3888L12.2977 14.6229L11.8927 14.7642L11.4471 14.6835L10.5316 13.4037L9.58785 11.9625L8.82633 10.6706L8.73316 10.7231L8.28354 15.5474L8.07291 15.7937L7.58684 15.9794L7.18177 15.6726L6.96709 15.176L7.18177 14.195L7.44101 12.9152L7.65165 11.8979L7.84203 10.6342L7.95544 10.2144L7.94734 10.1861L7.85418 10.1982L6.89823 11.5063L5.44405 13.4643L4.29367 14.6916L4.01823 14.8006L3.54025 14.5543L3.58481 14.1143L3.85215 13.7227L5.44405 11.7041L6.40405 10.4526L7.0238 9.72993L7.01975 9.62496H6.98329L2.75443 12.3621L2.00101 12.459L1.67696 12.1562L1.71747 11.6597L1.87139 11.4982L3.14329 10.6262L3.13924 10.6302Z" />
  ),
})

export const ChatGPTIcon = makeIcon({
  displayName: 'ChatGPTIcon',
  viewBox: 24,
  content: (
    <path
      d="M9.20509 8.7342V6.47454C9.20509 6.28422 9.27649 6.14143 9.44293 6.04639L13.9861 3.42997C14.6046 3.07322 15.342 2.90678 16.103 2.90678C18.9573 2.90678 20.7651 5.11892 20.7651 7.47363C20.7651 7.64007 20.7651 7.83038 20.7412 8.0207L16.0316 5.26149C15.7462 5.09505 15.4607 5.09505 15.1753 5.26149L9.20509 8.7342ZM19.8135 17.535V12.1355C19.8135 11.8024 19.6708 11.5646 19.3854 11.3981L13.4152 7.92542L15.3656 6.80742C15.5321 6.71237 15.6749 6.71237 15.8413 6.80742L20.3845 9.42383C21.6928 10.1851 22.5728 11.8024 22.5728 13.3722C22.5728 15.1799 21.5025 16.8451 19.8135 17.535ZM7.80173 12.7779L5.8513 11.6362C5.68486 11.5412 5.61346 11.3984 5.61346 11.2081V5.97522C5.61346 3.4302 7.56389 1.50342 10.2042 1.50342C11.2033 1.50342 12.1307 1.83652 12.9159 2.43111L8.2301 5.1428C7.94475 5.30924 7.80195 5.54707 7.80195 5.88018L7.80173 12.7779ZM12 15.204L9.20509 13.6342V10.3042L12 8.73443L14.7947 10.3042V13.6342L12 15.204ZM13.7958 22.435C12.7967 22.435 11.8693 22.1019 11.0841 21.5073L15.7699 18.7956C16.0553 18.6292 16.198 18.3913 16.198 18.0582V11.1603L18.1723 12.302C18.3388 12.397 18.4102 12.5398 18.4102 12.7301V17.963C18.4102 20.508 16.4359 22.435 13.7958 22.435ZM8.15848 17.1308L3.61528 14.5143C2.30696 13.7531 1.42701 12.1358 1.42701 10.566C1.42701 8.73443 2.52115 7.09323 4.20987 6.40337V11.8265C4.20987 12.1596 4.35266 12.3975 4.63802 12.5639L10.5846 16.0127L8.63415 17.1308C8.46771 17.2258 8.32492 17.2258 8.15848 17.1308ZM7.897 21.0316C5.20919 21.0316 3.23488 19.0098 3.23488 16.5123C3.23488 16.322 3.25875 16.1317 3.2824 15.9414L7.96817 18.653C8.25352 18.8195 8.53911 18.8195 8.82446 18.653L14.7947 15.2042V17.4639C14.7947 17.6542 14.7233 17.797 14.5568 17.892L10.0136 20.5084C9.39518 20.8652 8.65803 21.0316 7.897 21.0316ZM13.7958 23.862C16.6739 23.862 19.0762 21.8165 19.6235 19.1048C22.2874 18.415 24 15.9175 24 13.3725C24 11.7074 23.2865 10.0901 22.002 8.92451C22.121 8.42497 22.1924 7.92542 22.1924 7.42611C22.1924 4.02479 19.4331 1.47954 16.2458 1.47954C15.6037 1.47954 14.9852 1.57458 14.3668 1.78877C13.2963 0.742157 11.8215 0.0761719 10.2042 0.0761719C7.32606 0.0761719 4.92383 2.12165 4.37653 4.83334C1.7126 5.5232 0 8.0207 0 10.5657C0 12.2308 0.713506 13.8481 1.99795 15.0137C1.87904 15.5132 1.80764 16.0127 1.80764 16.5121C1.80764 19.9134 4.56685 22.4586 7.75421 22.4586C8.39632 22.4586 9.01478 22.3636 9.63324 22.1494C10.7035 23.196 12.1783 23.862 13.7958 23.862Z"
      fill="black"
    />
  ),
})

export const ChatGPTGreyIcon = makeIcon({
  displayName: 'ChatGPTGreyIcon',
  viewBox: 24,
  content: (
    <path d="M9.20509 8.7342V6.47454C9.20509 6.28422 9.27649 6.14143 9.44293 6.04639L13.9861 3.42997C14.6046 3.07322 15.342 2.90678 16.103 2.90678C18.9573 2.90678 20.7651 5.11892 20.7651 7.47363C20.7651 7.64007 20.7651 7.83038 20.7412 8.0207L16.0316 5.26149C15.7462 5.09505 15.4607 5.09505 15.1753 5.26149L9.20509 8.7342ZM19.8135 17.535V12.1355C19.8135 11.8024 19.6708 11.5646 19.3854 11.3981L13.4152 7.92542L15.3656 6.80742C15.5321 6.71237 15.6749 6.71237 15.8413 6.80742L20.3845 9.42383C21.6928 10.1851 22.5728 11.8024 22.5728 13.3722C22.5728 15.1799 21.5025 16.8451 19.8135 17.535ZM7.80173 12.7779L5.8513 11.6362C5.68486 11.5412 5.61346 11.3984 5.61346 11.2081V5.97522C5.61346 3.4302 7.56389 1.50342 10.2042 1.50342C11.2033 1.50342 12.1307 1.83652 12.9159 2.43111L8.2301 5.1428C7.94475 5.30924 7.80195 5.54707 7.80195 5.88018L7.80173 12.7779ZM12 15.204L9.20509 13.6342V10.3042L12 8.73443L14.7947 10.3042V13.6342L12 15.204ZM13.7958 22.435C12.7967 22.435 11.8693 22.1019 11.0841 21.5073L15.7699 18.7956C16.0553 18.6292 16.198 18.3913 16.198 18.0582V11.1603L18.1723 12.302C18.3388 12.397 18.4102 12.5398 18.4102 12.7301V17.963C18.4102 20.508 16.4359 22.435 13.7958 22.435ZM8.15848 17.1308L3.61528 14.5143C2.30696 13.7531 1.42701 12.1358 1.42701 10.566C1.42701 8.73443 2.52115 7.09323 4.20987 6.40337V11.8265C4.20987 12.1596 4.35266 12.3975 4.63802 12.5639L10.5846 16.0127L8.63415 17.1308C8.46771 17.2258 8.32492 17.2258 8.15848 17.1308ZM7.897 21.0316C5.20919 21.0316 3.23488 19.0098 3.23488 16.5123C3.23488 16.322 3.25875 16.1317 3.2824 15.9414L7.96817 18.653C8.25352 18.8195 8.53911 18.8195 8.82446 18.653L14.7947 15.2042V17.4639C14.7947 17.6542 14.7233 17.797 14.5568 17.892L10.0136 20.5084C9.39518 20.8652 8.65803 21.0316 7.897 21.0316ZM13.7958 23.862C16.6739 23.862 19.0762 21.8165 19.6235 19.1048C22.2874 18.415 24 15.9175 24 13.3725C24 11.7074 23.2865 10.0901 22.002 8.92451C22.121 8.42497 22.1924 7.92542 22.1924 7.42611C22.1924 4.02479 19.4331 1.47954 16.2458 1.47954C15.6037 1.47954 14.9852 1.57458 14.3668 1.78877C13.2963 0.742157 11.8215 0.0761719 10.2042 0.0761719C7.32606 0.0761719 4.92383 2.12165 4.37653 4.83334C1.7126 5.5232 0 8.0207 0 10.5657C0 12.2308 0.713506 13.8481 1.99795 15.0137C1.87904 15.5132 1.80764 16.0127 1.80764 16.5121C1.80764 19.9134 4.56685 22.4586 7.75421 22.4586C8.39632 22.4586 9.01478 22.3636 9.63324 22.1494C10.7035 23.196 12.1783 23.862 13.7958 23.862Z" />
  ),
})

export const CursorIcon = makeIcon({
  displayName: 'CursorIcon',
  viewBox: 24,
  content: (
    <path
      d="M22.1323 5.64966L12.5245 0.102678C12.216 -0.0754858 11.8353 -0.0754858 11.5268 0.102678L1.91947 5.64966C1.66012 5.79941 1.5 6.07633 1.5 6.37628V17.5618C1.5 17.8613 1.66012 18.1387 1.91947 18.2885L11.5272 23.8354C11.8358 24.0136 12.2164 24.0136 12.525 23.8354L22.1327 18.2885C22.3921 18.1387 22.5522 17.8617 22.5522 17.5618V6.37628C22.5522 6.07679 22.3917 5.79941 22.1323 5.64966ZM21.5288 6.82464L12.2539 22.8892C12.1912 22.9974 12.0257 22.9532 12.0257 22.8278V12.3089C12.0257 12.0987 11.9133 11.9043 11.7311 11.7988L2.62176 6.53957C2.51351 6.47689 2.55771 6.31132 2.6831 6.31132H21.2329C21.4963 6.31132 21.6605 6.59639 21.5288 6.82464Z"
      fill="black"
    />
  ),
})

export const CursorGreyIcon = makeIcon({
  displayName: 'CursorGreyIcon',
  viewBox: 24,
  content: (
    <path d="M22.1323 5.64966L12.5245 0.102678C12.216 -0.0754858 11.8353 -0.0754858 11.5268 0.102678L1.91947 5.64966C1.66012 5.79941 1.5 6.07633 1.5 6.37628V17.5618C1.5 17.8613 1.66012 18.1387 1.91947 18.2885L11.5272 23.8354C11.8358 24.0136 12.2164 24.0136 12.525 23.8354L22.1327 18.2885C22.3921 18.1387 22.5522 17.8617 22.5522 17.5618V6.37628C22.5522 6.07679 22.3917 5.79941 22.1323 5.64966ZM21.5288 6.82464L12.2539 22.8892C12.1912 22.9974 12.0257 22.9532 12.0257 22.8278V12.3089C12.0257 12.0987 11.9133 11.9043 11.7311 11.7988L2.62176 6.53957C2.51351 6.47689 2.55771 6.31132 2.6831 6.31132H21.2329C21.4963 6.31132 21.6605 6.59639 21.5288 6.82464Z" />
  ),
})

export const GeminiIcon = makeIcon({
  displayName: 'GeminiIcon',
  viewBox: 24,
  content: (
    <g>
      <mask
        id="gemini-mask"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="-1"
        width="24"
        height="25"
      >
        <path
          d="M11.9804 -0.0309448C12.2315 -0.0309448 12.4505 0.140747 12.5118 0.38444C12.6991 1.12978 12.9459 1.85889 13.2498 2.56475C14.0444 4.4109 15.1348 6.02666 16.519 7.4109C17.904 8.79552 19.5194 9.88586 21.3652 10.6804C22.0712 10.9843 22.8004 11.2311 23.5458 11.4185C23.7895 11.4798 23.9609 11.6984 23.9609 11.9495C23.9609 12.2006 23.7895 12.4195 23.5455 12.4808C22.8001 12.6681 22.071 12.9149 21.3652 13.2189C19.519 14.0135 17.9036 15.1038 16.519 16.4881C15.1348 17.8731 14.0444 19.4884 13.2498 21.3342C12.9458 22.0402 12.6989 22.7695 12.5114 23.5149C12.4817 23.6333 12.4134 23.7384 12.3172 23.8136C12.221 23.8888 12.1025 23.9297 11.9804 23.9299C11.7294 23.9299 11.5108 23.7586 11.4495 23.5145C11.262 22.7692 11.0151 22.0401 10.711 21.3342C9.9168 19.4881 8.82683 17.8727 7.44185 16.4881C6.05723 15.1038 4.44185 14.0135 2.59569 13.2189C1.88981 12.9149 1.16071 12.668 0.415385 12.4804C0.296968 12.4509 0.191809 12.3826 0.116568 12.2865C0.0413266 12.1904 0.000304454 12.0719 0 11.9499C0 11.6988 0.171692 11.4802 0.415385 11.4189C1.16074 11.2315 1.88985 10.9845 2.59569 10.6804C4.44185 9.88622 6.0576 8.79589 7.44185 7.41127C8.82646 6.02702 9.9168 4.41127 10.7114 2.56512C11.0152 1.85922 11.2621 1.13012 11.4495 0.384809C11.479 0.266263 11.5473 0.160975 11.6435 0.0856554C11.7397 0.0103357 11.8583 -0.0307019 11.9804 -0.0309448Z"
          fill="url(#gemini-gradient)"
        />
      </mask>
      <g mask="url(#gemini-mask)">
        <rect x="-1" y="-1" width="26" height="26" fill="#4285F4" />
        <g filter="url(#gemini-blur1)">
          <circle cx="10.4" cy="12.8" r="9" fill="#4285F4" />
        </g>
        <g filter="url(#gemini-blur2)">
          <circle cx="10.1" cy="0.9" r="7" fill="#FC413D" />
        </g>
        <g filter="url(#gemini-blur3)">
          <ellipse cx="7" cy="21" rx="7" ry="9" fill="#00B95C" />
        </g>
        <g filter="url(#gemini-blur4)">
          <circle cx="25" cy="9.3" r="7" fill="#3186FF" />
        </g>
        <g filter="url(#gemini-blur5)">
          <circle cx="-5" cy="8" r="8" fill="#FBBC04" />
        </g>
        <g filter="url(#gemini-blur6)">
          <circle cx="18" cy="12" r="9" fill="#3186FF" />
        </g>
        <g filter="url(#gemini-blur7)">
          <ellipse cx="15" cy="2.7" rx="5" ry="3.5" fill="#749BFF" />
        </g>
        <g filter="url(#gemini-blur8)">
          <ellipse cx="7" cy="1.2" rx="7" ry="7" fill="#FC413D" />
        </g>
        <g filter="url(#gemini-blur9)">
          <ellipse cx="5" cy="17" rx="5" ry="3.5" fill="#FFEE48" />
        </g>
        <g filter="url(#gemini-blur10)">
          <circle cx="-2" cy="12" r="5" fill="#FFE432" />
        </g>
      </g>
      <defs>
        <linearGradient
          id="gemini-gradient"
          x1="6.8"
          y1="16"
          x2="19.3"
          y2="5.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4893FC" />
          <stop offset="0.27" stopColor="#4893FC" />
          <stop offset="0.777" stopColor="#969DFF" />
          <stop offset="1" stopColor="#BD99FE" />
        </linearGradient>
        <filter
          id="gemini-blur1"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="2.7" />
        </filter>
        <filter
          id="gemini-blur2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="4.4" />
        </filter>
        <filter
          id="gemini-blur3"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="3.7" />
        </filter>
        <filter
          id="gemini-blur4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="3.5" />
        </filter>
        <filter
          id="gemini-blur5"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="3.2" />
        </filter>
        <filter
          id="gemini-blur6"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="2.9" />
        </filter>
        <filter
          id="gemini-blur7"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="2.6" />
        </filter>
        <filter
          id="gemini-blur8"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="2.2" />
        </filter>
        <filter
          id="gemini-blur9"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="2.7" />
        </filter>
        <filter
          id="gemini-blur10"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="0.9" />
        </filter>
      </defs>
    </g>
  ),
})

export const LovableIcon = makeIcon({
  displayName: 'LovableIcon',
  viewBox: 24,
  content: (
    <g>
      <mask
        id="lovable-mask"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="-1"
        width="24"
        height="25"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.12231 -0.0309448C11.055 -0.0309448 14.2446 3.14762 14.2446 7.06986V9.76864H16.6151C20.5478 9.76864 23.7374 12.9472 23.7374 16.8694C23.7374 20.7893 20.549 23.9691 16.6151 23.9691H0V7.06866C0 3.14762 3.18839 -0.0309448 7.12231 -0.0309448Z"
          fill="url(#lovable-gradient)"
        />
      </mask>
      <g mask="url(#lovable-mask)">
        <g filter="url(#lovable-blur1)">
          <circle cx="10.4" cy="12.8" r="16" fill="#4B73FF" />
        </g>
        <g filter="url(#lovable-blur2)">
          <ellipse cx="12.2" cy="4" rx="20" ry="12" fill="#FF66F4" />
        </g>
        <g filter="url(#lovable-blur3)">
          <circle cx="15.5" cy="1" r="13" fill="#FF0105" />
        </g>
        <g filter="url(#lovable-blur4)">
          <circle cx="12.5" cy="4" r="9.6" fill="#FE7B02" />
        </g>
      </g>
      <defs>
        <linearGradient
          id="lovable-gradient"
          x1="8"
          y1="4.2"
          x2="15.1"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.025" stopColor="#FF8E63" />
          <stop offset="0.56" stopColor="#FF7EB0" />
          <stop offset="0.95" stopColor="#4B73FF" />
        </linearGradient>
        <filter
          id="lovable-blur1"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="2.7" />
        </filter>
        <filter
          id="lovable-blur2"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="2.7" />
        </filter>
        <filter
          id="lovable-blur3"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="2.7" />
        </filter>
        <filter
          id="lovable-blur4"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feGaussianBlur stdDeviation="2.7" />
        </filter>
      </defs>
    </g>
  ),
})

export const N8nIcon = makeIcon({
  displayName: 'N8nIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3158 7.47369C13.531 7.47369 12.8716 6.93692 12.6846 6.21053H10.7542C10.3426 6.21053 9.9913 6.50815 9.92365 6.91418L9.85439 7.32955C9.7887 7.72387 9.58919 8.06702 9.30709 8.3158C9.58919 8.56457 9.7887 8.90773 9.85439 9.30204L9.92365 9.71741C9.9913 10.1234 10.3426 10.4211 10.7542 10.4211H11.0004C11.1874 9.69467 11.8468 9.1579 12.6316 9.1579C13.5618 9.1579 14.3158 9.91194 14.3158 10.8421C14.3158 11.7723 13.5618 12.5263 12.6316 12.5263C11.8468 12.5263 11.1874 11.9896 11.0004 11.2632H10.7542C9.93095 11.2632 9.22835 10.6679 9.09298 9.85587L9.02372 9.4405C8.95607 9.03446 8.60477 8.73685 8.19312 8.73685H7.5259C7.33895 9.46324 6.67951 10 5.89474 10C5.10996 10 4.45053 9.46324 4.26358 8.73685H3.31537C3.12842 9.46324 2.46898 10 1.68421 10C0.754049 10 0 9.24597 0 8.3158C0 7.38562 0.754049 6.63159 1.68421 6.63159C2.46898 6.63159 3.12842 7.16836 3.31537 7.89474H4.26358C4.45053 7.16836 5.10996 6.63159 5.89474 6.63159C6.67951 6.63159 7.33895 7.16836 7.5259 7.89474H8.19312C8.60477 7.89474 8.95607 7.59713 9.02372 7.19109L9.09298 6.77573C9.22835 5.96366 9.93095 5.36843 10.7542 5.36843H12.6846C12.8716 4.64204 13.531 4.10527 14.3158 4.10527C15.246 4.10527 16 4.85931 16 5.78948C16 6.71966 15.246 7.47369 14.3158 7.47369ZM14.3158 6.63159C14.7808 6.63159 15.1579 6.25453 15.1579 5.78948C15.1579 5.32443 14.7808 4.94738 14.3158 4.94738C13.8507 4.94738 13.4737 5.32443 13.4737 5.78948C13.4737 6.25453 13.8507 6.63159 14.3158 6.63159ZM1.68421 9.1579C2.14926 9.1579 2.52632 8.78085 2.52632 8.3158C2.52632 7.85074 2.14926 7.47369 1.68421 7.47369C1.21913 7.47369 0.842105 7.85074 0.842105 8.3158C0.842105 8.78085 1.21913 9.1579 1.68421 9.1579ZM6.73684 8.3158C6.73684 8.78085 6.35979 9.1579 5.89474 9.1579C5.42968 9.1579 5.05263 8.78085 5.05263 8.3158C5.05263 7.85074 5.42968 7.47369 5.89474 7.47369C6.35979 7.47369 6.73684 7.85074 6.73684 8.3158ZM13.4737 10.8421C13.4737 11.3072 13.0966 11.6842 12.6316 11.6842C12.1665 11.6842 11.7895 11.3072 11.7895 10.8421C11.7895 10.3771 12.1665 10 12.6316 10C13.0966 10 13.4737 10.3771 13.4737 10.8421Z"
      fill="#EA4B71"
    />
  ),
})

export const N8nGreyIcon = makeIcon({
  displayName: 'N8nGreyIcon',
  viewBox: 16,
  content: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3158 7.47368C13.531 7.47368 12.8716 6.9369 12.6846 6.21052H10.7542C10.3426 6.21052 9.9913 6.50813 9.92365 6.91417L9.85439 7.32954C9.7887 7.72385 9.58919 8.06701 9.30709 8.31578C9.58919 8.56455 9.7887 8.90771 9.85439 9.30203L9.92365 9.7174C9.9913 10.1234 10.3426 10.421 10.7542 10.421H11.0004C11.1874 9.69466 11.8468 9.15789 12.6316 9.15789C13.5618 9.15789 14.3158 9.91192 14.3158 10.8421C14.3158 11.7723 13.5618 12.5263 12.6316 12.5263C11.8468 12.5263 11.1874 11.9895 11.0004 11.2631H10.7542C9.93095 11.2631 9.22835 10.6679 9.09298 9.85585L9.02372 9.44048C8.95607 9.03445 8.60477 8.73683 8.19312 8.73683H7.5259C7.33895 9.46322 6.67951 9.99999 5.89474 9.99999C5.10996 9.99999 4.45053 9.46322 4.26358 8.73683H3.31537C3.12842 9.46322 2.46898 9.99999 1.68421 9.99999C0.754049 9.99999 0 9.24596 0 8.31578C0 7.38561 0.754049 6.63157 1.68421 6.63157C2.46898 6.63157 3.12842 7.16834 3.31537 7.89473H4.26358C4.45053 7.16834 5.10996 6.63157 5.89474 6.63157C6.67951 6.63157 7.33895 7.16834 7.5259 7.89473H8.19312C8.60477 7.89473 8.95607 7.59711 9.02372 7.19108L9.09298 6.77571C9.22835 5.96364 9.93095 5.36841 10.7542 5.36841H12.6846C12.8716 4.64203 13.531 4.10526 14.3158 4.10526C15.246 4.10526 16 4.85929 16 5.78947C16 6.71964 15.246 7.47368 14.3158 7.47368ZM14.3158 6.63157C14.7808 6.63157 15.1579 6.25452 15.1579 5.78947C15.1579 5.32441 14.7808 4.94736 14.3158 4.94736C13.8507 4.94736 13.4737 5.32441 13.4737 5.78947C13.4737 6.25452 13.8507 6.63157 14.3158 6.63157ZM1.68421 9.15789C2.14926 9.15789 2.52632 8.78083 2.52632 8.31578C2.52632 7.85073 2.14926 7.47368 1.68421 7.47368C1.21913 7.47368 0.842105 7.85073 0.842105 8.31578C0.842105 8.78083 1.21913 9.15789 1.68421 9.15789ZM6.73684 8.31578C6.73684 8.78083 6.35979 9.15789 5.89474 9.15789C5.42968 9.15789 5.05263 8.78083 5.05263 8.31578C5.05263 7.85073 5.42968 7.47368 5.89474 7.47368C6.35979 7.47368 6.73684 7.85073 6.73684 8.31578ZM13.4737 10.8421C13.4737 11.3071 13.0966 11.6842 12.6316 11.6842C12.1665 11.6842 11.7895 11.3071 11.7895 10.8421C11.7895 10.377 12.1665 9.99999 12.6316 9.99999C13.0966 9.99999 13.4737 10.377 13.4737 10.8421Z"
    />
  ),
})

export const SalesforceIcon = makeIcon({
  displayName: 'SalesforceIcon',
  viewBox: 16,
  content: (
    <g>
      <mask
        id="salesforce-mask"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="2"
        width="16"
        height="12"
      >
        <path d="M0 2.5H16V13.6765H0V2.5Z" fill="white" />
      </mask>
      <g mask="url(#salesforce-mask)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.64353 3.72352C7.16 3.18588 7.87882 2.85293 8.67294 2.85293C9.73177 2.85293 10.6494 3.44117 11.1435 4.31764C11.5821 4.12157 12.0572 4.02034 12.5376 4.02058C14.4435 4.02058 15.9906 5.5794 15.9906 7.50293C15.9906 9.42646 14.4435 10.9853 12.5376 10.9853C12.3047 10.9853 12.0776 10.9619 11.8553 10.9176C11.4229 11.6882 10.5965 12.2118 9.65529 12.2118C9.27211 12.2125 8.89383 12.1256 8.54941 11.9576C8.11118 12.9871 7.09059 13.7106 5.90235 13.7106C4.66118 13.7106 3.60824 12.9282 3.20235 11.8282C3.0217 11.8664 2.83757 11.8855 2.65294 11.8854C1.17647 11.8854 -0.0176468 10.6736 -0.0176468 9.1854C-0.0176468 8.1854 0.52 7.31482 1.31765 6.84423C1.14843 6.4544 1.06132 6.0339 1.06176 5.60893C1.06176 3.89129 2.45588 2.50305 4.17353 2.50305C5.17941 2.50305 6.07941 2.98246 6.64412 3.72658"
          fill="#00A1E0"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.31412 8.31176C2.30406 8.33799 2.3177 8.34346 2.32094 8.34811C2.351 8.36988 2.38153 8.38564 2.41212 8.40335C2.57565 8.48982 2.72976 8.51511 2.89094 8.51511C3.21918 8.51511 3.42329 8.34041 3.42329 8.05923V8.0537C3.42329 7.7937 3.1927 7.69899 2.97741 7.63135L2.94923 7.62223C2.78629 7.56941 2.6457 7.52341 2.6457 7.41635V7.41088C2.6457 7.31911 2.72806 7.25146 2.85512 7.25146C2.99629 7.25146 3.16453 7.29846 3.27218 7.35793C3.27218 7.35793 3.30406 7.37852 3.31565 7.34776C3.32194 7.33111 3.37682 7.18423 3.3827 7.16776C3.38894 7.15052 3.378 7.13752 3.36676 7.13082C3.24323 7.05552 3.07265 7.00435 2.89617 7.00435L2.86341 7.00446C2.56282 7.00446 2.35282 7.18623 2.35282 7.44623V7.45182C2.35282 7.72593 2.58459 7.81535 2.80106 7.87711L2.83588 7.88793C2.99353 7.93641 3.13 7.97852 3.13 8.08911V8.09464C3.13 8.19641 3.04118 8.27229 2.89882 8.27229C2.84347 8.27229 2.66706 8.27135 2.47588 8.15052C2.45276 8.13705 2.43959 8.12735 2.42176 8.11646C2.41235 8.11076 2.38882 8.10046 2.37859 8.13129L2.31388 8.31129M7.11976 8.31129C7.1097 8.33752 7.12335 8.34299 7.1267 8.34764C7.15665 8.36941 7.18729 8.38517 7.21788 8.40288C7.38141 8.48935 7.53553 8.51464 7.6967 8.51464C8.02494 8.51464 8.22906 8.33993 8.22906 8.05876V8.05323C8.22906 7.79323 7.99906 7.69852 7.78317 7.63088L7.755 7.62176C7.59206 7.56893 7.45147 7.52293 7.45147 7.41588V7.4104C7.45147 7.31864 7.53382 7.25099 7.66088 7.25099C7.80206 7.25099 7.9697 7.29799 8.07794 7.35746C8.07794 7.35746 8.10982 7.37805 8.12147 7.34729C8.1277 7.33064 8.18265 7.18376 8.18794 7.16729C8.19423 7.15005 8.18323 7.13705 8.17206 7.13035C8.04853 7.05505 7.87794 7.00388 7.70147 7.00388L7.66865 7.00399C7.36806 7.00399 7.15806 7.18576 7.15806 7.44576V7.45135C7.15806 7.72546 7.38982 7.81488 7.60629 7.87664L7.64106 7.88746C7.79929 7.93593 7.93517 7.97805 7.93517 8.08864V8.09417C7.93517 8.19593 7.84635 8.27182 7.704 8.27182C7.64853 8.27182 7.47165 8.27088 7.28106 8.15005C7.25794 8.13658 7.24441 8.12729 7.22688 8.11599C7.22094 8.11223 7.19323 8.1014 7.18376 8.13082L7.11906 8.31082M10.4014 7.76023C10.4014 7.91905 10.3718 8.04435 10.3138 8.13317C10.2559 8.22082 10.1685 8.26376 10.0467 8.26376C9.92494 8.26376 9.83788 8.22117 9.78082 8.13376C9.72335 8.04552 9.69435 7.91964 9.69435 7.76082C9.69435 7.60199 9.72353 7.47729 9.78082 7.38964C9.83776 7.30258 9.92435 7.26082 10.0467 7.26082C10.1691 7.26082 10.2561 7.30299 10.3138 7.38964C10.3721 7.47729 10.4014 7.60199 10.4014 7.76082M10.6755 7.46611C10.6485 7.37493 10.6067 7.29493 10.5508 7.22788C10.4949 7.16082 10.4244 7.1067 10.3402 7.06788C10.2567 7.02876 10.1579 7.00905 10.0461 7.00905C9.93435 7.00905 9.83612 7.02888 9.752 7.06788C9.66847 7.10693 9.59729 7.16082 9.54141 7.22788C9.48565 7.29493 9.44376 7.37493 9.4167 7.46611C9.38994 7.5567 9.37635 7.65552 9.37635 7.76082C9.37635 7.86611 9.38994 7.96493 9.4167 8.05552C9.44359 8.1467 9.48553 8.2267 9.54141 8.29376C9.59735 8.36082 9.66847 8.41435 9.752 8.45258C9.83612 8.4907 9.93494 8.51011 10.0461 8.51011C10.1573 8.51011 10.2561 8.4907 10.3396 8.45258C10.4232 8.41446 10.4944 8.36082 10.5502 8.29376C10.6061 8.2267 10.6479 8.1467 10.6749 8.05552C10.7016 7.96493 10.7152 7.86611 10.7152 7.76082C10.7152 7.65611 10.7016 7.5567 10.6749 7.46611M12.9279 8.21905C12.9189 8.1924 12.8929 8.20246 12.8929 8.20246C12.8531 8.2177 12.8105 8.23182 12.7652 8.23888C12.7196 8.24605 12.6688 8.24964 12.6152 8.24964C12.4829 8.24964 12.377 8.21017 12.3017 8.13199C12.2258 8.05376 12.1835 7.92788 12.1841 7.75729C12.1845 7.60199 12.222 7.48552 12.2894 7.39611C12.3558 7.30788 12.4582 7.26199 12.5935 7.26199C12.7064 7.26199 12.7929 7.27511 12.8835 7.30346C12.8835 7.30346 12.9049 7.31282 12.9152 7.28452C12.9393 7.21805 12.9571 7.1704 12.9829 7.09746C12.9902 7.07658 12.9723 7.06776 12.9658 7.06523C12.9302 7.05135 12.8464 7.02858 12.7828 7.01899C12.7234 7.00993 12.6546 7.00523 12.5769 7.00523C12.4616 7.00523 12.3593 7.02493 12.2716 7.06399C12.184 7.10299 12.1099 7.15693 12.0511 7.22399C11.9922 7.29105 11.9475 7.37105 11.9175 7.46223C11.8878 7.55282 11.8728 7.65223 11.8728 7.75752C11.8728 7.98458 11.934 8.1687 12.0552 8.3034C12.1764 8.4387 12.3587 8.50693 12.5964 8.50693C12.7369 8.50693 12.8811 8.47852 12.9846 8.43752C12.9846 8.43752 13.0044 8.42799 12.9958 8.40493L12.9281 8.21905M13.4075 7.60729C13.4206 7.51905 13.4448 7.44552 13.4828 7.38846C13.5397 7.3014 13.6264 7.25376 13.7481 7.25376C13.8699 7.25376 13.9505 7.30164 14.0081 7.38846C14.0464 7.44582 14.0631 7.52199 14.0693 7.60729L13.4046 7.60717L13.4075 7.60729ZM14.3311 7.41317C14.3077 7.32552 14.2499 7.2367 14.2122 7.19611C14.1522 7.13199 14.094 7.0867 14.0358 7.06199C13.9517 7.02624 13.8612 7.00789 13.7699 7.00805C13.654 7.00805 13.5487 7.02764 13.4634 7.06746C13.3781 7.10758 13.3064 7.16217 13.2499 7.23041C13.1935 7.29864 13.1511 7.37923 13.124 7.47158C13.0969 7.56276 13.0833 7.66276 13.0833 7.76746C13.0833 7.87452 13.0975 7.97393 13.1254 8.06393C13.1535 8.15452 13.1989 8.23393 13.2601 8.29982C13.3212 8.36629 13.3995 8.41805 13.4936 8.45452C13.5871 8.4907 13.7006 8.50946 13.8306 8.50905C14.0989 8.50817 14.2401 8.44846 14.2977 8.41611C14.308 8.41035 14.3177 8.4004 14.3056 8.37176L14.245 8.20176C14.2357 8.1764 14.2101 8.18558 14.2101 8.18558C14.1436 8.2104 14.0495 8.25499 13.8289 8.2544C13.6848 8.25417 13.5783 8.21164 13.5112 8.14499C13.443 8.07676 13.4089 7.97735 13.4036 7.83617L14.333 7.83688C14.333 7.83688 14.3575 7.83664 14.36 7.81276C14.361 7.80288 14.3918 7.62217 14.3323 7.41335L14.3311 7.41317ZM5.97812 7.60729C5.99123 7.51905 6.01547 7.44552 6.05341 7.38846C6.11035 7.3014 6.19694 7.25376 6.3187 7.25376C6.44047 7.25376 6.52106 7.30164 6.5787 7.38846C6.61688 7.44582 6.63359 7.52199 6.63988 7.60729L5.97518 7.60717L5.97812 7.60729ZM6.90165 7.41317C6.87835 7.32552 6.82047 7.2367 6.78282 7.19611C6.72282 7.13199 6.66459 7.0867 6.60635 7.06199C6.52228 7.02624 6.43183 7.00789 6.34047 7.00805C6.22459 7.00805 6.11929 7.02764 6.034 7.06746C5.9487 7.10758 5.87694 7.16217 5.82047 7.23041C5.76418 7.29864 5.72165 7.37923 5.69459 7.47158C5.66759 7.56276 5.654 7.66276 5.654 7.76746C5.654 7.87452 5.66806 7.97393 5.69612 8.06393C5.72423 8.15452 5.76965 8.23393 5.83023 8.29982C5.89141 8.36629 5.96965 8.41805 6.06376 8.45452C6.15729 8.4907 6.27023 8.50946 6.40082 8.50905C6.66906 8.50817 6.81023 8.44846 6.86788 8.41611C6.87812 8.41035 6.88788 8.4004 6.8757 8.37176L6.81512 8.20176C6.80576 8.1764 6.78012 8.18558 6.78012 8.18558C6.71365 8.2104 6.61953 8.25499 6.39894 8.2544C6.25541 8.25417 6.14835 8.21164 6.08129 8.14499C6.01306 8.07676 5.97894 7.97735 5.97365 7.83617L6.90306 7.83688C6.90306 7.83688 6.92753 7.83664 6.93006 7.81276C6.93106 7.80288 6.96188 7.62217 6.90229 7.41335L6.90165 7.41317ZM3.97223 8.21317C3.93582 8.18411 3.93076 8.17699 3.9187 8.15811C3.90029 8.1297 3.89088 8.08929 3.89088 8.03752C3.89088 7.95635 3.91794 7.89752 3.97382 7.85811C3.97323 7.85823 4.05382 7.7887 4.24323 7.79105C4.32754 7.79256 4.41165 7.79974 4.495 7.81252V8.23429H4.49512C4.49512 8.23429 4.37747 8.25964 4.24453 8.26764C4.0557 8.27899 3.97218 8.21329 3.97276 8.21346L3.97223 8.21317ZM4.34165 7.56023C4.304 7.55746 4.25517 7.55611 4.19694 7.55611C4.11753 7.55611 4.04047 7.56599 3.9687 7.58541C3.89635 7.60493 3.83106 7.63517 3.77517 7.67541C3.71914 7.71538 3.67305 7.76771 3.64047 7.82835C3.60759 7.88952 3.59082 7.96129 3.59082 8.04246C3.59082 8.12482 3.60512 8.19599 3.63335 8.25423C3.66102 8.31199 3.70267 8.36193 3.75453 8.39952C3.80612 8.43705 3.86982 8.46482 3.94335 8.48129C4.01629 8.49793 4.09865 8.50635 4.18923 8.50635C4.28453 8.50635 4.37923 8.49835 4.471 8.48288C4.54915 8.4694 4.62702 8.45425 4.70453 8.43746C4.73547 8.43035 4.76982 8.42099 4.76982 8.42099C4.79276 8.41517 4.791 8.39064 4.791 8.39064L4.79047 7.54358C4.79047 7.3577 4.74082 7.21946 4.64282 7.13417C4.54518 7.04888 4.40223 7.00593 4.21694 7.00593C4.14753 7.00593 4.03517 7.01535 3.96812 7.02882C3.96812 7.02882 3.76576 7.06811 3.68223 7.13352C3.68223 7.13352 3.66388 7.14482 3.67388 7.17041L3.73976 7.34688C3.74794 7.36976 3.77023 7.36193 3.77023 7.36193C3.77023 7.36193 3.77723 7.35917 3.78547 7.35429C3.9637 7.25723 4.18959 7.26017 4.18959 7.26017C4.28959 7.26017 4.36723 7.28046 4.419 7.32017C4.46965 7.35905 4.49547 7.41782 4.49547 7.54135V7.58058C4.41606 7.56905 4.34253 7.5624 4.34253 7.5624L4.34165 7.56023ZM11.8122 7.08199C11.8136 7.07889 11.8143 7.07555 11.8143 7.07217C11.8143 7.0688 11.8137 7.06545 11.8123 7.06233C11.811 7.05921 11.8091 7.05639 11.8067 7.05403C11.8043 7.05166 11.8014 7.04981 11.7983 7.04858C11.7825 7.04258 11.7036 7.02593 11.643 7.02217C11.5265 7.01488 11.4618 7.03452 11.4036 7.06064C11.3461 7.08658 11.2824 7.12829 11.2471 7.17652L11.247 7.06358C11.247 7.04805 11.236 7.03552 11.2204 7.03552H10.9827C10.9673 7.03552 10.9561 7.04805 10.9561 7.06358V8.44593C10.9561 8.4534 10.9591 8.46056 10.9644 8.46584C10.9697 8.47112 10.9768 8.4741 10.9843 8.47411H11.2278C11.2353 8.4741 11.2424 8.47112 11.2477 8.46584C11.253 8.46055 11.2559 8.4534 11.2559 8.44593V7.75182C11.2559 7.65888 11.2662 7.56652 11.2866 7.50829C11.3067 7.4507 11.3341 7.40476 11.3678 7.37182C11.3999 7.34 11.4393 7.31639 11.4825 7.30299C11.523 7.29136 11.565 7.28546 11.6072 7.28546C11.6557 7.28546 11.7089 7.29793 11.7089 7.29793C11.7268 7.29993 11.7368 7.28899 11.7428 7.27288C11.7588 7.23046 11.804 7.10346 11.8128 7.07817"
        fill="#FFFFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.53771 6.44399C9.50761 6.43489 9.47698 6.42762 9.446 6.42222C9.40433 6.41527 9.36213 6.412 9.31988 6.41246C9.15206 6.41246 9.01977 6.45987 8.92688 6.55352C8.83465 6.64646 8.77188 6.78805 8.74041 6.97434L8.72906 7.03722H8.51841C8.51841 7.03722 8.49271 7.03616 8.4873 7.06422L8.45271 7.25716C8.4503 7.27563 8.45824 7.28716 8.48294 7.28704H8.688L8.47994 8.4484C8.46365 8.54193 8.445 8.61887 8.42435 8.67716C8.404 8.73469 8.38412 8.77781 8.35965 8.8091C8.33594 8.8394 8.31347 8.86169 8.27471 8.87469C8.24271 8.88546 8.20588 8.8904 8.16553 8.8904C8.14306 8.8904 8.11318 8.88663 8.09112 8.88222C8.06906 8.87787 8.05759 8.87293 8.04106 8.86599C8.04106 8.86599 8.017 8.85681 8.00753 8.88093C7.99983 8.90063 7.94518 9.05093 7.93871 9.06952C7.93212 9.08787 7.94135 9.10234 7.953 9.10652C7.9803 9.11628 8.00059 9.12252 8.03777 9.13128C8.08941 9.14346 8.13294 9.14422 8.17371 9.14422C8.25912 9.14422 8.33694 9.13222 8.40147 9.10893C8.46641 9.08546 8.52294 9.04457 8.57294 8.98922C8.627 8.92952 8.661 8.86699 8.69353 8.78169C8.72571 8.69716 8.75312 8.59222 8.77506 8.46993L8.98412 7.28704H9.28977C9.28977 7.28704 9.31553 7.28799 9.32088 7.26004L9.35547 7.0671C9.35788 7.04863 9.35 7.0371 9.32518 7.03722H9.02853C9.03 7.03052 9.04347 6.92616 9.07753 6.82793C9.09206 6.78599 9.11941 6.75216 9.14259 6.72893C9.16423 6.7068 9.19088 6.69021 9.2203 6.68057C9.25254 6.67061 9.28614 6.66576 9.31988 6.66622C9.34783 6.66622 9.37524 6.66957 9.39612 6.67393C9.42488 6.68005 9.43606 6.68328 9.44359 6.68552C9.47382 6.69475 9.47788 6.68581 9.48383 6.67116L9.55477 6.47634C9.56206 6.4554 9.5443 6.44657 9.53771 6.44399ZM5.39218 8.45087C5.39218 8.4664 5.38112 8.47904 5.36559 8.47904H5.11953C5.10394 8.47904 5.09288 8.4664 5.09288 8.45087V6.4704C5.09288 6.45493 5.10394 6.4424 5.11953 6.4424H5.36559C5.38112 6.4424 5.39218 6.45493 5.39218 6.4704V8.45087Z"
        fill="#FFFFFE"
      />
    </g>
  ),
})

export const SalesforceGreyIcon = makeIcon({
  displayName: 'SalesforceGreyIcon',
  viewBox: 16,
  content: (
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.64352 3.72352C7.15999 3.18588 7.87882 2.85293 8.67293 2.85293C9.73176 2.85293 10.6494 3.44117 11.1435 4.31764C11.5821 4.12157 12.0572 4.02034 12.5376 4.02058C14.4435 4.02058 15.9906 5.5794 15.9906 7.50293C15.9906 9.42646 14.4435 10.9853 12.5376 10.9853C12.3047 10.9853 12.0776 10.9619 11.8553 10.9176C11.4229 11.6882 10.5965 12.2118 9.65529 12.2118C9.2721 12.2125 8.89382 12.1256 8.5494 11.9576C8.11117 12.9871 7.09058 13.7106 5.90235 13.7106C4.66117 13.7106 3.60823 12.9282 3.20235 11.8282C3.0217 11.8664 2.83756 11.8855 2.65293 11.8854C1.17646 11.8854 -0.0176544 10.6736 -0.0176544 9.1854C-0.0176544 8.1854 0.519993 7.31482 1.31764 6.84423C1.14842 6.4544 1.06131 6.0339 1.06176 5.60893C1.06176 3.89129 2.45587 2.50305 4.17352 2.50305C5.1794 2.50305 6.0794 2.98246 6.64411 3.72658"
      />
      <path
        d="M9.44623 6.42183C9.47716 6.42723 9.50797 6.43521 9.53802 6.44429C9.54488 6.44706 9.56179 6.45596 9.55463 6.47652L9.48431 6.67085C9.47837 6.6855 9.47353 6.69474 9.4433 6.6855C9.43579 6.68328 9.42465 6.67979 9.39642 6.67378C9.37563 6.66945 9.34807 6.666 9.32025 6.66597C9.28661 6.66551 9.25279 6.67071 9.22064 6.68062C9.19131 6.69023 9.16412 6.70643 9.14252 6.72847C9.11934 6.75171 9.09162 6.78614 9.07709 6.82808C9.04324 6.92583 9.02982 7.02959 9.02826 7.03706H9.32513C9.34996 7.03695 9.35782 7.04887 9.35541 7.06734L9.32123 7.25972C9.31615 7.28621 9.29239 7.28708 9.28998 7.28706H8.98431L8.77533 8.46968C8.75342 8.59181 8.72542 8.69673 8.6933 8.7812C8.66079 8.86644 8.62718 8.92954 8.57318 8.98921C8.52318 9.04456 8.46625 9.08586 8.40131 9.10933C8.33685 9.13255 8.25903 9.14448 8.17377 9.14449C8.13304 9.14449 8.08961 9.14296 8.03802 9.13081C8.00085 9.12205 7.98035 9.11616 7.95306 9.1064C7.94142 9.10222 7.93183 9.08764 7.93842 9.06929C7.94504 9.05027 8.00006 8.90048 8.00775 8.88081C8.01703 8.85749 8.03983 8.86575 8.04095 8.86617C8.05737 8.87306 8.06899 8.87746 8.09076 8.88179C8.11282 8.8862 8.14348 8.89058 8.16595 8.89058C8.20597 8.89055 8.24256 8.88559 8.27435 8.87495C8.31293 8.86202 8.33573 8.8396 8.35931 8.80952C8.38378 8.77823 8.40439 8.73424 8.42474 8.67671C8.44532 8.61848 8.46416 8.54145 8.48041 8.4482L8.68842 7.28706H8.48334C8.45863 7.28718 8.45065 7.27526 8.45306 7.25679L8.48724 7.06441C8.49266 7.03635 8.51849 7.03706 8.51849 7.03706H8.72943L8.74017 6.97456C8.77162 6.78839 8.83456 6.64661 8.9267 6.55367C9.01958 6.46002 9.15243 6.41206 9.32025 6.41206C9.36238 6.41163 9.40468 6.41489 9.44623 6.42183ZM2.89642 7.00386C3.07281 7.00391 3.24365 7.05555 3.36713 7.13081C3.37827 7.13756 3.38894 7.15082 3.38275 7.16792C3.37662 7.18506 3.3217 7.33087 3.31537 7.34761C3.30449 7.37649 3.27588 7.36046 3.2724 7.35835C3.16483 7.29892 2.99653 7.25197 2.85541 7.25191C2.72835 7.25191 2.64545 7.31932 2.64545 7.41109V7.41597C2.64545 7.523 2.78627 7.56922 2.94916 7.62202L2.97748 7.63179C3.19271 7.69943 3.42375 7.79376 3.42377 8.05367V8.05952C3.42362 8.34052 3.21868 8.51558 2.89056 8.51558C2.72953 8.51554 2.57545 8.48968 2.41205 8.40327C2.38163 8.38567 2.35113 8.37018 2.32123 8.34859C2.31959 8.34624 2.31499 8.3432 2.31244 8.33784L2.31342 8.31148L2.37885 8.13081C2.38913 8.1007 2.41239 8.11048 2.42181 8.11617C2.43955 8.12699 2.45262 8.13698 2.47552 8.15034C2.66618 8.27084 2.84252 8.27241 2.89838 8.27242C3.04071 8.27242 3.12979 8.19642 3.12982 8.09468V8.08882C3.12959 7.97844 2.99339 7.93608 2.83588 7.88765L2.80072 7.87691C2.58443 7.81517 2.35264 7.72583 2.35248 7.4521V7.44624C2.35248 7.1863 2.56274 7.00492 2.86322 7.00484L2.89642 7.00386ZM7.70111 7.00386C7.87758 7.00386 8.04828 7.05552 8.17181 7.13081C8.18289 7.13747 8.19436 7.14994 8.18842 7.16695C8.18312 7.18342 8.12727 7.33096 8.12103 7.34761C8.10951 7.37706 8.07942 7.35824 8.07806 7.35738C7.96988 7.29793 7.80221 7.25097 7.66107 7.25093C7.53415 7.25093 7.45128 7.31849 7.45111 7.41011V7.41597C7.4512 7.52294 7.59197 7.56923 7.75482 7.62202L7.78314 7.63081C7.99902 7.69846 8.22943 7.79367 8.22943 8.05367V8.05855C8.22943 8.33972 8.02446 8.5146 7.69623 8.5146C7.53524 8.51455 7.38107 8.48965 7.21771 8.40327C7.18716 8.38559 7.1568 8.36933 7.12689 8.34761C7.12524 8.34532 7.12069 8.34294 7.1181 8.33784L7.11908 8.3105L7.18353 8.13081C7.1929 8.10172 7.22016 8.1123 7.2265 8.11617C7.24403 8.12746 7.25807 8.13687 7.28119 8.15034C7.47169 8.27103 7.64859 8.27144 7.70404 8.27144C7.84637 8.27143 7.93549 8.19546 7.93549 8.0937V8.08882C7.93549 7.97835 7.79957 7.93606 7.64154 7.88765L7.60638 7.87691C7.38991 7.81514 7.15814 7.72524 7.15814 7.45113V7.44527C7.1584 7.18553 7.36848 7.00386 7.66888 7.00386H7.70111ZM10.0458 7.00874C10.1575 7.00874 10.2563 7.02926 10.3398 7.06831C10.4238 7.10708 10.4948 7.16056 10.5507 7.22749C10.6065 7.29442 10.6477 7.37481 10.6747 7.46577C10.7014 7.55633 10.7148 7.65603 10.7148 7.7607C10.7148 7.86599 10.7014 7.96503 10.6747 8.05562C10.6477 8.14667 10.6065 8.22691 10.5507 8.2939C10.4949 8.36088 10.4232 8.41399 10.3398 8.4521C10.2563 8.49022 10.157 8.50972 10.0458 8.50972C9.93478 8.50969 9.83594 8.49019 9.75189 8.4521C9.66848 8.41388 9.59684 8.36089 9.54095 8.2939C9.48516 8.22691 9.4438 8.14667 9.41693 8.05562C9.39017 7.96503 9.37592 7.86599 9.37592 7.7607C9.37593 7.65544 9.39018 7.55633 9.41693 7.46577C9.44399 7.37475 9.48527 7.29446 9.54095 7.22749C9.59678 7.16051 9.66848 7.10736 9.75189 7.06831C9.83594 7.02935 9.93419 7.00878 10.0458 7.00874ZM6.34076 7.00777C6.43202 7.00765 6.5224 7.02674 6.60638 7.06245C6.66456 7.08718 6.72321 7.1322 6.78314 7.19624C6.82077 7.23691 6.87802 7.32562 6.90131 7.41304H6.90228C6.96144 7.62034 6.93104 7.80018 6.92963 7.81245C6.92723 7.83509 6.90556 7.83678 6.90326 7.83687L5.97357 7.83589C5.97887 7.97707 6.01276 8.07723 6.08099 8.14546C6.14806 8.21206 6.25588 8.2546 6.39935 8.25484C6.61965 8.25537 6.71378 8.21031 6.78021 8.1855C6.78197 8.18491 6.80636 8.17768 6.81537 8.2021L6.87592 8.37202C6.88781 8.40023 6.87822 8.41021 6.8681 8.41597C6.81049 8.4483 6.66923 8.50779 6.40131 8.50874C6.27072 8.50916 6.15694 8.49023 6.06342 8.45406C5.9695 8.41759 5.89109 8.36612 5.83002 8.29976C5.7696 8.23402 5.72434 8.15474 5.69623 8.06441C5.66818 7.97443 5.65424 7.87456 5.65424 7.76753C5.65424 7.66288 5.6673 7.56277 5.69427 7.47163C5.72132 7.37934 5.76401 7.29863 5.82025 7.23042C5.87672 7.16219 5.94882 7.10745 6.03412 7.06734C6.11939 7.02756 6.22494 7.00777 6.34076 7.00777ZM13.7695 7.00777C13.8608 7.00761 13.952 7.0267 14.0361 7.06245C14.0941 7.08718 14.152 7.13234 14.2119 7.19624C14.2495 7.23681 14.3076 7.32544 14.331 7.41304H14.332C14.3909 7.61989 14.3618 7.79948 14.3603 7.81245C14.3578 7.83634 14.3329 7.83687 14.3329 7.83687L13.4033 7.83589C13.4086 7.97707 13.4434 8.07723 13.5117 8.14546C13.5787 8.21185 13.6852 8.2546 13.829 8.25484C14.0494 8.2554 14.1435 8.21033 14.2099 8.1855C14.2099 8.1855 14.2358 8.17675 14.2451 8.2021L14.3056 8.37202C14.3175 8.40038 14.308 8.41021 14.2978 8.41597C14.2402 8.44831 14.099 8.50781 13.831 8.50874C13.7011 8.50915 13.5876 8.49016 13.4941 8.45406C13.4 8.41759 13.3209 8.36623 13.2597 8.29976C13.1987 8.23399 13.1531 8.15477 13.1249 8.06441C13.0971 7.97443 13.083 7.87456 13.0829 7.76753C13.0829 7.66285 13.0969 7.56279 13.124 7.47163C13.151 7.37928 13.1935 7.29866 13.2499 7.23042C13.3064 7.16219 13.3785 7.10745 13.4638 7.06734C13.5489 7.02768 13.6539 7.00781 13.7695 7.00777ZM4.21674 7.00581C4.40179 7.00581 4.54488 7.04867 4.64252 7.13374C4.74052 7.21904 4.79095 7.35802 4.79095 7.5439V8.39058C4.79095 8.39058 4.79241 8.41503 4.76947 8.42085C4.76605 8.42178 4.73415 8.43074 4.70502 8.43745C4.6275 8.45425 4.5488 8.46987 4.47064 8.48335C4.37906 8.49877 4.28449 8.50678 4.18939 8.50679C4.0988 8.50679 4.01624 8.49805 3.9433 8.4814C3.86984 8.46494 3.80638 8.43685 3.75482 8.39937C3.70296 8.36178 3.6614 8.31162 3.63373 8.25386C3.60559 8.19576 3.59081 8.12501 3.59076 8.04292C3.59076 7.96175 3.60768 7.88926 3.64056 7.82808C3.67312 7.76757 3.7194 7.71565 3.77533 7.67574C3.83121 7.6355 3.89634 7.60444 3.96869 7.58492C4.04043 7.56552 4.11783 7.55562 4.1972 7.55562C4.25533 7.55562 4.30414 7.55774 4.34174 7.5605L4.34271 7.56245C4.34675 7.56282 4.41806 7.56984 4.49506 7.58101V7.54097C4.495 7.41769 4.46948 7.35911 4.41888 7.32027C4.36712 7.28057 4.28938 7.25972 4.18939 7.25972C4.1817 7.25965 3.96021 7.25909 3.7851 7.35445C3.77746 7.35893 3.77115 7.36198 3.77045 7.36226C3.77045 7.36226 3.74835 7.36952 3.74017 7.34663L3.67377 7.17085C3.66377 7.14526 3.68256 7.13374 3.68256 7.13374C3.76377 7.07022 3.95683 7.0314 3.96771 7.02925C4.0347 7.01579 4.14731 7.00583 4.21674 7.00581ZM12.5771 7.00484C12.6547 7.00484 12.7238 7.00946 12.7831 7.01851C12.8466 7.02812 12.9303 7.05152 12.9658 7.06538C12.9723 7.06794 12.9906 7.07678 12.9833 7.09761C12.9575 7.17046 12.939 7.2178 12.915 7.28413C12.9054 7.31051 12.8863 7.30465 12.8837 7.30367C12.7932 7.27533 12.7065 7.26169 12.5937 7.26167C12.4584 7.26167 12.3555 7.3082 12.289 7.39644C12.2218 7.4858 12.1849 7.6027 12.1845 7.75777C12.184 7.92803 12.226 8.05362 12.3017 8.13179C12.377 8.20995 12.4829 8.24994 12.6152 8.24995C12.6687 8.24995 12.7199 8.24639 12.7656 8.23921C12.8107 8.23215 12.8528 8.21728 12.8925 8.2021C12.8925 8.2021 12.9186 8.19252 12.9277 8.2187L12.996 8.40523C13.0043 8.42803 12.9843 8.43745 12.9843 8.43745C12.8809 8.47838 12.737 8.50676 12.5966 8.50679C12.3592 8.50679 12.1768 8.43872 12.0556 8.30367C11.9345 8.16901 11.873 7.98471 11.873 7.75777C11.873 7.65247 11.8882 7.55246 11.9179 7.46187C11.9479 7.37087 11.992 7.29054 12.0507 7.22359C12.1095 7.15664 12.184 7.10338 12.2714 7.06441C12.3591 7.02535 12.4618 7.00484 12.5771 7.00484ZM5.36517 6.44234C5.3807 6.44234 5.39252 6.45519 5.39252 6.47066V8.45113C5.39239 8.46654 5.38062 8.47945 5.36517 8.47945H5.11908C5.10382 8.4792 5.09284 8.46638 5.09271 8.45113V6.47066C5.09271 6.45534 5.10374 6.44258 5.11908 6.44234H5.36517ZM11.6435 7.02242C11.704 7.02624 11.783 7.0428 11.7988 7.04878C11.8016 7.04997 11.8043 7.05154 11.8066 7.05367C11.809 7.05603 11.8111 7.05934 11.8124 7.06245C11.8137 7.06553 11.8144 7.06889 11.8144 7.07222L11.8124 7.07808C11.8036 7.10339 11.7592 7.22955 11.7431 7.27242C11.737 7.28853 11.7268 7.29981 11.7089 7.29781C11.7071 7.29738 11.655 7.28514 11.6074 7.28511C11.5652 7.2851 11.5229 7.29105 11.4824 7.30269C11.4392 7.31608 11.4002 7.34024 11.3681 7.37202C11.3344 7.40497 11.3072 7.45116 11.287 7.50874C11.2667 7.56699 11.2558 7.65911 11.2558 7.75191V8.44624C11.2557 8.45351 11.2531 8.46058 11.248 8.46577C11.2427 8.47106 11.2349 8.47455 11.2275 8.47456H10.9843C10.9769 8.47455 10.97 8.47095 10.9648 8.46577C10.9596 8.46057 10.9561 8.4536 10.956 8.44624V7.06343C10.9561 7.04808 10.9672 7.0353 10.9824 7.03511H11.2206C11.2361 7.03526 11.2469 7.04806 11.247 7.06343V7.17671C11.2823 7.12854 11.3458 7.08645 11.4033 7.0605C11.4615 7.03438 11.527 7.01512 11.6435 7.02242ZM4.2431 7.79097C4.05424 7.78866 3.97337 7.85814 3.97357 7.85835C3.91799 7.89769 3.89066 7.95626 3.89056 8.03706C3.89056 8.08883 3.90047 8.12975 3.91888 8.15816C3.93089 8.17695 3.93626 8.18385 3.9726 8.21284V8.21382C3.97547 8.21628 4.05951 8.27852 4.24408 8.26753L4.49506 8.23433V7.81245C4.41171 7.79967 4.32741 7.79248 4.2431 7.79097ZM10.0468 7.2607C9.92455 7.2607 9.83813 7.30267 9.78119 7.3896C9.72391 7.47723 9.69429 7.60193 9.69427 7.7607C9.69427 7.91952 9.72372 8.04551 9.78119 8.13374C9.83825 8.22105 9.92512 8.26363 10.0468 8.26363C10.1685 8.2636 10.2555 8.22039 10.3134 8.13277C10.3569 8.06617 10.3844 7.97933 10.3954 7.873L10.4013 7.7607C10.4013 7.60193 10.3718 7.47723 10.3134 7.3896C10.2558 7.3031 10.169 7.26072 10.0468 7.2607ZM13.748 7.25386C13.6263 7.2539 13.5392 7.3016 13.4824 7.38863C13.4445 7.44564 13.4203 7.51931 13.4072 7.60738H14.0693C14.063 7.52208 14.046 7.44598 14.0078 7.38863C13.9501 7.30184 13.8697 7.25386 13.748 7.25386ZM6.3183 7.25386C6.19675 7.25397 6.11053 7.30167 6.05365 7.38863C6.01571 7.44568 5.99157 7.51915 5.97845 7.60738H6.63959C6.6333 7.52222 6.61709 7.44595 6.57904 7.38863C6.52139 7.3018 6.44006 7.25386 6.3183 7.25386Z"
        fill="white"
      />
    </g>
  ),
})

export const SlabGreyIcon = makeIcon({
  displayName: 'SlabGreyIcon',
  viewBox: 16,
  content: (
    <g clipPath="url(#slab-mono-clip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7.99999V3.90944C0 1.7503 1.79088 0 4.00007 0H4.2334H11.7616H11.9949C14.2042 0 15.995 1.68643 15.995 3.76674V5.3H7.99486L7.991 5.28816L8.00014 7.99999H0ZM1.54999 6.52405H6.43479V5.87231H1.54999V6.52405ZM1.54999 5.03821H6.43479V4.38647H1.54999V5.03821ZM1.54999 3.55229H6.43479V2.90002H1.54999V3.55229ZM0.00485229 10.78H8.00503C8.00503 10.78 8.00646 10.7844 8.00927 10.793L7.99986 8.00006H16V12.0906C16 14.2497 14.2091 16 11.9999 16H11.3773C11.5051 16.0449 11.635 16.0724 11.7665 16.08H4.00496C1.79577 16.08 0.00485229 14.3936 0.00485229 12.3133V10.78ZM14.4148 10.1517H9.53V9.5H14.4148V10.1517ZM14.4148 11.6381H9.53V10.9858H14.4148V11.6381ZM14.4148 13.1239H9.53V12.4717H14.4148V13.1239Z"
        fill="currentColor"
      />
      <defs>
        <clipPath id="slab-mono-clip">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </g>
  ),
})

export const SlabIcon = makeIcon({
  displayName: 'SlabIcon',
  viewBox: 16,
  content: (
    <g clipPath="url(#slab-color-clip)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99486 5.3H15.995V3.76674C15.995 1.68643 14.2042 0 11.9949 0H4.2334C6.32745 0.120226 7.99486 5.3 7.99486 5.3Z"
        fill="#50C5DC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00014 7.99999H0V3.90944C0 1.7503 1.79088 0 4.00007 0H11.7616C9.66754 0.124782 7.98633 1.82329 7.98633 3.9013C7.98633 3.90405 8.00014 7.99999 8.00014 7.99999Z"
        fill="#FCB415"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00503 10.78H0.00485229V12.3133C0.00485229 14.3936 1.79577 16.08 4.00496 16.08H11.7665C9.67247 15.9598 8.00503 10.78 8.00503 10.78Z"
        fill="#741448"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99986 8.00006H16V12.0906C16 14.2497 14.2091 16 11.9999 16H4.2384C6.33246 15.8753 8.01367 14.1768 8.01367 12.0987C8.01367 12.096 7.99986 8.00006 7.99986 8.00006Z"
        fill="#FF4143"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.54999 6.52405H6.43479V5.87231H1.54999V6.52405Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.54999 5.03821H6.43479V4.38647H1.54999V5.03821Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.54999 3.55229H6.43479V2.90002H1.54999V3.55229Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.53 10.1517H14.4148V9.5H9.53V10.1517Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.53 11.6381H14.4148V10.9858H9.53V11.6381Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.53 13.1239H14.4148V12.4717H9.53V13.1239Z"
        fill="white"
      />
      <defs>
        <clipPath id="slab-color-clip">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </g>
  ),
})
